const nl = {
  "datalogger": {
    "cancel": "Annuleren",
    "resetData": "Gegevens resetten",
    "device_upgrade": "Apparaatfirmware upgrade",
    "batchAddScq": "Batch gegevensverzamelaar toevoegen",
    "updatefail": "Upgrade mislukt, collector is mogelijk offline of controleer of communicatie met collector normaal i",
    "Normal1": "Online status",
    "deleteSuc": "Succesvol verwijderd",
    "county": "Graafschap/district",
    "Instruction": "Instructies:",
    "select_file": "Selecteer firmware",
    "rebootDataloggerSuc": "De gegevensverzamelaar is succesvol opnieuw gestart",
    "confirm_deldte": "Nadat u de gegevensverzamelaar hebt verwijderd, bent u niet meer bevoegd om alle gegevens die verband houden met de gegevensverzamelaar te beheren",
    "buyProfitNew": "Aankoopprijs van elektriciteit",
    "datalogger_debug": "Debugging van gegevensverzamelaars",
    "province": "Provincie/Staat",
    "clear_data": "Gegevens wissen",
    "Flowcard_status": "Status verkeerskaart",
    "reAdd": "Opnieuw toevoegen",
    "connectionInfo": "Verbindingsinformatie",
    "location_info": "Positiegegevens",
    "editDatalogger": "Gegevensverzameling wijzigen",
    "Status": "Staat",
    "Ple_Alias": "Voer de naam van de gegevensverzamelaar in",
    "unbindResults": "Onbindende resultaten",
    "editResults": "Resultaten wijzigen",
    "upgrade": "Upgrade",
    "edit": "Bewerken",
    "Offline": "Off-line",
    "timeZone": "Tijdzone",
    "please_title": "Gelieve 'YES' in te voeren om de fabrieksreset te bevestigen.",
    "frequency": "Verzamelfrequentie",
    "heartbeat": "hartslag",
    "warehousing_time": "opslagtijd",
    "start_address": "Start-adres van de enquête",
    "deadline_address": "Deadline address",
    "title_usr": "Deze gegevensverzamelaar heeft geen gelieerde gebruiker",
    "datalogger_log": "Log",
    "min_addr": "minimumadres",
    "max_addr": "Maximum adres",
    "transmission": "Pure transparante identificatie",
    "transparent_set": "Pure transparante protocolset",
    "devcode": "Code van de fabrikant van apparatuur",
    "protocol_code": "Protocol fabrikant code",
    "domain_name": "Online domeinnaam",
    "transmission1": "Local collection mode",
    "transmission2": "Pure transparante modus",
    "noDate": "Selecteer een datum binnen drie dagen",
    "paramSetting": "Parameterinstellingen",
    "paramName": "Parameternaam",
    "paramPar": "Parameternummer",
    "paramVal": "De waarde van de parameter",
    "dataloggerView": "Data collector details",
    "describe": "Beschrijving",
    "field_name": "Veldnaam",
    "checkVal": "Numerieke waarde",
    "resetTitle1": "Weet u zeker dat u de gegevensverzamelaar wilt resetten? (1: maak hem opnieuw registraeerbaar, 2: verwijder ondergeschikte apparaten, 3: verwijder alle gegevens onder de verzamelaar)",
    "unbingTitle": "Weet u zeker dat u de gegevensverzamelaar wilt loskoppelen? (1: Maak de dealerbeheerder los; 2: Rebind, log in bij de betreffende dealerbeheerder om de gegevensverzamelaar toe te voegen)",
    "getTitle": "Parameter acquisition",
    "postTitle": "Parameter Settings",
    "debugeTitle": "Debugging instellen",
    "getName": "Parameteracquisitie (decimaal)",
    "postName": "Parameternummer (decimaal)",
    "debugeName": "Command:",
    "getVal": "Huidige waarde:",
    "postVal": "Setting value:",
    "debugeVal": "Resultaat:",
    "debugeAddr": "Apparaatadres:",
    "getSucc": "succesvol verkregen",
    "postSucc": "Set success",
    "debugeSucc": "Succesvol uitgegeven",
    "copyVal": "Kopieer waarde",
    "huoqu": "Get",
    "shezhi": "Instellingen",
    "xiafa": "Geef commando",
    "unbindDataloggerName": "Gegevensverzameling ontkoppelen",
    "Communication_balance": "Saldo communicatievergoedingen",
    "add_suc": "Succesvol toegevoegd",
    "sellProfit": "Verkoopprijs van elektriciteit:",
    "nominalPower": "Nominaal vermogen",
    "Datalogger_List": "Lijst met gegevensverzamelaars",
    "installer": "Installateur",
    "delResults": "Resultaten verwijderen",
    "reset": "Reset",
    "Datalogger_type": "Type gegevensverzamelaar",
    "addResults": "Resultaten toevoegen",
    "resetTitle": "Voer 'JA' in om te bevestigen dat u de gegevensverzamelaar wilt resetten.",
    "upDatalogger": "Upgrade van gegevensverzamelaar",
    "datalogger_pn": "PN-gegevensverzamelaar:",
    "continueAdding": "Doorgaan met toevoegen",
    "resetCode": "Voer JA in om te bevestigen",
    "city": "Stad",
    "latitude": "Breedtegraad",
    "notActive": "Niet actief",
    "Upload": "Upload firmware",
    "prompt_message": "Herinneringsinformatie",
    "usr_belong": "Gebruiker",
    "unitProfit": "Prijs elektriciteitsverbruik:",
    "locationTip": "Vriendelijke herinnering: handmatige invoer is beschikbaar wanneer positionering onnauwkeurig of ineffectief is",
    "basicInfo": "Basisinformatie",
    "Firmware_Version": "Firmware versie",
    "upSuccessDatalogger": "Met succes opgewaardeerde gegevensverzamelaar",
    "unbindDataloggerExplain": "Deze functie is hoofdzakelijk voor het gemak van fabrikanten om de testaccount (eigenaar) met de gegevensverzamelaar los te koppelen nadat de pre-shipment testen is voltooid. Bedien deze functie zorgvuldig. Eenmaal bediend, zullen klanten de gegevensverzamelaar opnieuw moeten binden.",
    "resetDataloggerExplain": "Deze functie wordt voornamelijk gebruikt om fabrikanten te vergemakkelijken om cloud testgegevens op hun apparaten te wissen. Na het resetten van de gegevensverzamelaar worden de historische gegevens van het apparaat gewist. Eenmaal in gebruik, kunnen de historische gegevens van het apparaat niet worden hersteld. Wees voorzichtig!",
    "resetResults": "Resultaten resetten",
    "currency": "Ontvangstvaluta:",
    "copy": "Succesvol gekopieerd",
    "datalogger_name": "Naam gegevensverzamelaar:",
    "Datalogger_model": "Model",
    "debug_suc": "Debuggen succesvol",
    "cp10": "Voer een projectnaam in",
    "address": "Positie gegevensverzamelaar",
    "cp2": "Selecteer een tijdzone",
    "cp1": "Selecteer de installatiedatum",
    "cp4": "Selecteer een inkomstenvaluta",
    "more": "Meer",
    "cp3": "Voer het nominale vermogen in",
    "cp6": "Selecteer het project waartoe u behoort",
    "cp5": "Voer een apparaatnaam in",
    "finishAdding": "Oltooiing van de toevoeging",
    "cp7": "Selecteer lengte- en breedtegraad",
    "lonRange": "Nummers met een lengtegraad van -180 tot 180",
    "latRange": "Getallen binnen de breedtegraad van -90 tot 90",
    "upFailDatalogger": "Foute gegevensverzamelaars upgraden",
    "Normal": "Normaal",
    "cp9": "Voer het huidige adres in",
    "resetSuc": "Reset succesvol",
    "confirm": "Bevestigen",
    "modify_datalog": "Wijziging van informatie over gegevensverzamelaars",
    "activeStatus": "Activeringsstatus",
    "com_method": "Communicatiemethode",
    "Debugfail": "Debuggen mislukt, gegevensverzamelaar is offline",
    "sellProfitNew": "Verkoopprijs van elektriciteit",
    "Online": "Online",
    "uploadSuccess": "Upload succesvol",
    "country": "Land",
    "location_info1": "Geografische informatie",
    "buyProfit": "Aankoopprijs van elektriciteit:",
    "resetDataloggerName": "Gegevensverzameling opnieuw instellen",
    "Datalogger_Status": "Status gegevensverzamelaar",
    "editDataloggerName": "Gegevensverzameling bewerken",
    "modifySuc": "Met succes gewijzigd",
    "Ple_PN": "Voer het PN-nummer van de gegevensverzamelaar in",
    "devaddrfail": "Het postadres kan niet leeg zijn",
    "Allstate": "Alle statussen",
    "longi_lati": "Breedte en lengtegraad",
    "create": "Vaststellen",
    "finish": "Compleet",
    "install_date": "Installatietijd",
    "such_as": "Bijvoorbeeld: AA BB CC DD EE FF",
    "signal": "Signaal",
    "longitude": "Lengtegraad",
    "unbindSuc": "Koppeling succesvol losmaken",
    "editSuc": "De gegevensverzamelaar succesvol gewijzigd",
    "add": "Apparaat toevoegen",
    "Offline1": "Offline status",
    "enterPosition": "Positie van invoergegevensverzamelaar",
    "upBatchDataloggerTip": "Opmerking: Batch upgrade is het upgraden van meerdere gegevensverzamelaars naar dezelfde gegevensverzamelaarfirmware. Als u niet zeker weet welke firmware geschikt is voor de gegevensverzamelaar, kies dan zorgvuldig!",
    "unbindTitle": "Voer 'JA' in om te bevestigen dat u de gegevensverzamelaar wilt loskoppelen van de huidige terminal eigenaar.",
    "update_suc": "Upgrade succesvol",
    "flowCard": "Geen geldige kaarten gevonden",
    "Active": "Geactiveerd",
    "unbind": "Onbindend",
    "return_content": "Retourneer inhoud:",
    "district": "Administratief district",
    "rebootDataloggerName": "Start de gegevensverzamelaar opnieuw op",
    "send": "Instructies verzenden",
    "Datalogger_PN": "PN-nummer van gegevensverzamelaar",
    "generateProfitNew": "Prijs voor elektriciteitsopwekking",
    "Datalogger_Name": "Naam gegevensverzamelaar",
    "file_fist": "Selecteer eerst de firmware die u wilt upgraden",
    "income_info": "Informatie over inkomsten",
    "timezone": "Tijdzone",
    "addedSuccessfully": "Succesvol toegevoegd",
    "unbindUsr": "Ontbind de eigenaar",
    "Operation": "Werking",
    "GPRS_traffic": "GPRS-verkeer",
    "delete": "Verwijderen",
    "nowNoAdd": "Niet tijdelijk toegevoegd",
    "administrator": "Aangesloten beheerder",
    "dataloggerAddress": "Gedetailleerd adres",
    "load": "Draagcapaciteit",
    "addSuc": "Met succes toegevoegde gegevensverzamelaar",
    "Datalogger_method": "Communicatiemethode",
    "fixOnRebootDataloggerName1": "Is het?",
    "fileExceed": "Bestand te groot",
    "reboot": "Herstarten",
    "generateProfit": "Prijs elektriciteitsopwekking:",
    "noNegative": "Voer een niet negatief nummer in",
    "basic_info": "Basisinformatie",
    "debug": "Debuggen",
    "fixOnRebootDataloggerName": "Herstarten van de gegevensverzamelaar bevestigen:",
    "select_firmware": "Firmware:",
    "communication_address": "Postadres:",
    "check": "Controle",
    "InstructionType": "Instructieformaat",
    "endMarker": "Eindmarkering",
    "noMarker": "Geen eindmarkering",
    "noCheck": "Geen controle",
    "InstructionIssue": "Instructie verzenden",
    "Insufficient": "Onvoldoende aantal",
    "add_datalogger": "Nieuwe gegevensverzamelaar",
    "currentAddress": "Huidige adres:",
    "deleteTitle": "Gegevensverzameling verwijderen",
    "timezone1": "Tijdzone",
    "addScq": "Gegevensverzameling toevoegen",
    "instruction_response": "Commando verzenden, wachten op antwoord",
    "error1": "Alleen bestanden in de formaten \". bin\" en \". hex\" kunnen worden geüpload",
    "dataloggerTipName": "De verzamelaar is toegevoegd, toegevoegd door",
        "batch_edit_datalogger": "Datalogger batch bewerken",
        "upload_column_tips": "Vriendelijke herinnering: Kolom A is Datalogger PN, Kolom B is laadaantal, Kolom C is baudrate, Kolom D is communicatieprotocol, Kolom E is apparaatfabrikantcode, Kolom F is protocolfabrikantcode, Kolom G is verzamelmodus, Kolom H is min communicatieadres, Kolom I is max communicatieadres, geen titel nodig, zie onderstaande afbeelding",
        "upload_csv_tips": "Vriendelijke herinnering: Het bestandsformaat moet csv zijn, zie onderstaande afbeelding voor de inhoud",
        "click_enlarge": "Klik om te vergroten voor details",
            "collector_expire_time": "Vervaltijd van verzamelaar",
            "collection_cycle": "Verzamelcyclus",
                "ascii_display": "ASCII-weergave:"
  },
  "constant": {
    "gmt_neg_5": "(GMT 05:00) Eastern Time (Verenigde Staten en Canada), Indiana (Eastern)",
    "gmt_neg_4": "(GMT -04:00) Atlantische Tijd (Canada), Cuaba, La Paz, San Diego",
    "gmt_neg_7": "(GMT 07:00) Mountain Time (VS en Canada), Chihuahua, La Paz, Mazatlan, Arizona",
    "gmt_neg_6": "(GMT 06:00) Centrale Tijd (Verenigde Staten en Canada), Midden-Amerika, Mexico-Stad, Monterrey, Guadalajara",
    "gmt_neg_1": "(GMT -01:00) Kaapverdische eilanden, Azoren",
    "gmt_neg_3": "(GMT -03:00) Brasilia, Buenos Aires, Groenland, Cayenne",
    "gmt_neg_2": "(GMT 02:00) Midden Atlantische Oceaan",
    "gmt_11": "(GMT+11:00) Salomonseilanden, Vladivostok, Nieuw-Caledonië",
    "gmt_55": "(GMT+05:30) New Delhi",
    "gmt_10": "(GMT+10:00) Brisbane, Guam, Canberra, Melbourne, Sydney",
    "gmt_13": "(GMT+13:00) Nukualofa",
    "gmt_12": "(GMT+12:00) Auckland, Wellington, Fiji, Magadan",
    "gmt_neg_9": "(GMT -09:00) Alaska",
    "gmt_neg_8": "(GMT 08:00) Pacific Time (Verenigde Staten en Canada), Neder-Californië",
    "gmt0": "(GMT+00:00) Dublin, Edinburgh, Lissabon, Londen, Casablanca, Gecoördineerde Universele Tijd",
    "gmt_9": "(GMT+09:00) Osaka, Tokio, Seoel",
    "gangbi": "HKD(HK$)",
    "gmt_7": "(GMT+07:00) Bangkok, Hanoi, Jakarta, Novosibirsk",
    "gmt_8": "(GMT+08:00) Beijing, Chongqing, Hong Kong Special Administrative Region, Urumqi, Taipei, Kuala Lumpur, Singapore",
    "gmt_5": "(GMT+05:00) Islamabad, Karachi",
    "gmt_6": "(GMT+06:00) Dhaka, Astana, Jekaterinburg",
    "gmt_65": "(GMT +06:30) Myanmar",
    "gmt_neg_11": "(GMT -11:00) Samoa Eilanden",
    "gmt_3": "(GMT+03:00) Bagdad, Koeweit, Riyad, Nairobi, Teheran",
    "ruidian": "SEK(Kr)",
    "gmt_neg_12": "(GMT -12:00) Internationale Datumlijn West",
    "gmt_4": "(GMT+04:00) Abu Dhabi, Muscat, Yerevan",
    "gmt_1": "(GMT+01:00) Parijs, Madrid, Kopenhagen, Rome, Wenen, Berlijn, Amsterdam, West Centraal Afrika",
    "baxi": "BRL(R$)",
    "gmt_2": "(GMT+02:00) Amman, Damascus, Caïro, Athene, Jeruzalem, Istanbul",
    "renminbi": "RMB(￥)",
    "lubi": "INR(₹)",
    "gmt_neg_10": "(GMT -10:00) Hawaii",
    "Rand": "ZAR(R)",
    "moxige": "Mex($)",
    "yingbang": "GBP(£)",
    "Pakistani": "PKR (Rs)",
    "aoyuan": "AUD($A)",
    "meiyuan": "USD($)",
    "ouyuan": "EUR(€)"
  },
  "cloudsUpgarde": {
    "cloudsFirmwareList": "Cloud-upgradelijst",
    "cloudsFirmware": "Cloud Upgrade Firmware"
  },
  "role": {
    "all": "Alle",
    "viewer": "Power Station Viewer",
    "plantOwnerNew": "Gewone gebruikers",
    "plantOwner": "Eigenaar van een elektriciteitscentrale",
    "distributor": "Dealer",
    "group": "Groepsrekening",
    "manufacturer": "Rekening van de fabrikant"
  },
  "CollectorCountByOMSOrder": {
    "23": "De code van de fabrikant is ongeldig. Neem contact op met de beheerder",
    "12": "Er is geen geldig collector PN nummer onder de bestelling, bevestig het bestelnummer",
    "1": "Operatie mislukt",
    "772": "De bestelling heeft al een verzamelaar gebonden. Bevestig dat de verzamelaar in de bestelling niet gebonden is.",
    "259": "Er zijn ongeldige verzamelaars onder deze bestelling. Neem contact op met de beheerder",
    "7": "Ontbrekende noodzakelijke parameters",
    "8": "Geweigerd, neem contact op met de beheerder",
    "261": "Kan de toegewezen distributeur niet vinden, neem contact op met de beheerder"
  },
  "project": {
    "energyCurrent": "Huidige stroom",
    "tipCard": "Kaart",
    "energyMonth": "Maandelijkse elektriciteitsopwekking",
    "upload": "Afbeeldingen uploaden",
    "createResults": "Nieuw resultaat",
    "back": "Terugkeer",
    "project": "Project",
    "createProject": "Nieuw project",
    "deviceSn": "Apparaat SN",
    "createSuc": "Nieuw succesvol aangemaakt",
    "modifySuc": "Succes",
    "delSuc": "Succesvol verwijderd",
    "upgradeSuc": "Upgrade succesvol",
    "tipList": "Lijst",
    "moveSelect": "Geselecteerd verplaatsen",
    "limit": "(Beeldgrootte bedraagt niet meer dan 1M)",
    "placeholder": "Zoeken naar apparaatnaam/PN/SN",
    "defaultProject": "Standaard project",
    "energyDate": "Dagelijkse stroomopwekking",
    "editSuc": "Met succes bewerkt",
    "editProject": "Project bewerken",
    "move": "Bewegen",
    "energyTotal": "Totale elektriciteitsopwekking",
    "tipSearchPN": "Zoeken op gegevensverzamelaar",
    "editResults": "Resultaten bewerken",
    "projectRemark": "Projectbeschrijving",
    "manageProject": "Projectbeheer",
    "upgradeResults": "Resultaten upgraden",
    "energyYear": "Elektriciteitsopwekking in het lopende jaar",
    "delResults": "Resultaten verwijderen",
    "delProject": "Item verwijderen",
    "tipSearchSN": "Zoeken op apparaat",
    "projectName": "Naam van de invoer",
    "choice": "Scherm",
    "projectId": "Project ID",
    "moveTo": "Verplaatsen naar"
  },
  "Upload": {
    "Upload": "Upload"
  },
  "login": {
    "code": "Schuif de onderste schuifregelaar om de puzzel te voltooien",
    "forgotUser": "Account vergeten",
    "scanning": "Scannen",
    "loginSuc": "Inloggen succesvol",
    "pv123": "PV123 ESS",
    "YZcode": "Voer de verificatiecode in",
    "login": "Inloggen",
    "scan_download": "Mobiele scancode downloaden APP",
    "YHLogin": "Gebruikersaanmelding",
    "scan_login": "Inloggen met scancode",
    "usr": "Gebruikersnaam",
    "SmartESS": "Guangchu-schat",
    "forgotPwd": "Wachtwoord vergeten?",
    "app_download": "APP downloaden",
    "invitationLogin": "Inloggen met ervaringscode",
    "pwdformat": "Wachtwoord formaat (6<=wachtwoordlengte<=32)",
    "usrformat": "Accountformaat (2<=gebruikerslengte<=32)",
    "Pleaseconfirm_login": "Gelieve login te bevestigen",
    "remember_pwd": "Wachtwoord onthouden",
    "YZcode_format": "Het formaat van de verificatiecode is onjuist. Voer een nummer in",
    "invitation": "Ervaringscode",
    "no_invitation": "Heb je nog geen ervaringscode? Neem contact met ons op",
    "signup": "Registreer nu",
    "linkman": "Yibang Sunshine",
    "sample_station": "Demo",
    "X_Tech": "X-Tech",
    "success": "Succes",
    "no_account_yet": "Heb je nog geen account?",
    "Scancode_login": "Login scannen",
    "pwd": "Wachtwoord",
    "open": "Open",
    "Swipe_right": "Naar rechts schuiven",
    "no_validitycode": "De uitnodigingscode is niet geldig",
		"auto_login": "Automatisch inloggen",
  },
  "customize": {
    "orange": "Zoete sinaasappel",
    "green": "Vers groen",
    "classic": "Roze",
    "blue": "Klassiek blauw",
    "purple": "Paars",
    "switchSkin": "Huid wisselen"
  },
  "password": {
    "PLConfig_newpassword": "Bevestig het nieuwe wachtwoord",
    "Current_password": "Oud wachtwoord:",
    "User_name": "Gebruikersnaam:",
    "PLNew_password": "Voer een nieuw wachtwoord in",
    "New_password": "Nieuw wachtwoord:",
    "Save": "Bewaren",
    "PLCurrent_password": "Voer uw oude wachtwoord in",
    "editPwdSuc": "Wachtwoord wijziging succesvol!",
    "Config_newpassword": "Bevestig nieuw wachtwoord:",
    "loginAgain": "Wachtwoord succesvol gewijzigd, logt u opnieuw in",
    "Password": "Wachtwoord wijzigen"
  },
  "recharge": {
    "cancel": "Annuleren",
    "early_warning": "Waarschuwing voor vervaldatum van verkeerskaart",
    "orderno": "Ordernummer",
    "Recharge_tip4": "Gebruikers die zich voor PayPal hebben geregistreerd aanbevelen om het te gebruiken",
    "recharge_type": "type",
    "Recharge_tip3": "Aanbevolen voor WeChat-gebruikers die het al hebben geïnstalleerd",
    "Recharge1": "Opladen van het verkeer",
    "rechargeStatus": "Oplaadstatus",
    "Recharge_tip5": "WeChat betalen",
    "openWx": "Open uw mobiele WeChat-account",
    "Hint_language": "Uw apparaat heeft een 2G apparaat. Op verzoek van het ministerie van Industrie en Informatietechnologie worden 2G-netwerken geleidelijk uitgefaserd en wordt aanbevolen 4G-apparaten aan te schaffen en te vervangen!",
    "rechMoney": "Betaling",
    "Recharge": "Opladen",
    "Recharge_tip": "Herinnering opladen",
    "Dead_Time": "Vervaltijd",
    "domestic": "binnenlands",
    "not_for_the_time_being": "Niet tijdelijk te verwerken",
    "Hint_language1": "Als u problemen ondervindt tijdens het oplaadproces, neem dan contact op met de klantenservice hotline op 0755-89993588",
    "rechDiscount": "Korting",
    "Search": "Zoeken",
    "warning": "Vroegtijdige waarschuwing",
    "Recharge_tip2": "Kies bijvoorbeeld: dezelfde draagkracht is 1; Hetzelfde kaarttype is 4G; Bulk opladen voor het vasteland van China datakaarten in dezelfde regio",
    "Recharge_tip1": "Ondersteunt alleen bulk opladen van kaarten van hetzelfde type",
    "rechScan": "Open uw telefoon WeChat en scan om de betaling te voltooien",
    "rechTip": "Herinnering: 1. Alleen apparaten met hetzelfde kaarttype (zoals 4G binnenlands), dezelfde laadcapaciteit en dezelfde platformstatus voor armoedebestrijding kunnen voor dezelfde volgorde worden geselecteerd (standaarddisplay toont pakketten met een laadcapaciteit van 1 en niet verbonden met het platform voor armoedebestrijding); 2. Het opladen van achterstallige kaarten en opladen tussen de 25e en 5e van elke maand zal resulteren in een vertraging van 1-14 dagen. Wees geduldig en wacht",
    "Traffic_status": "Verkeersstatus",
    "Status": "Status verkeerskaart",
    "DataloggerPN": "PN:",
    "Recharge_money": "Oplaadbedrag",
    "Overdue": "Te laat",
    "Cancel_recharge": "Opladen annuleren",
    "Datalogger_List": "Lijst met gegevensverzamelaars",
    "Recharged": "Opgeladen met succes",
    "Rcharge_Month": "Maanden opladen",
    "Service_Area": "Dienstgebied",
    "Datalogger_PN": "PN-nummer van gegevensverzamelaar",
    "rechargeDevice": "Oplaadapparaat:",
    "rechargeSucInfo": "U heeft de betaling succesvol gedaan en het verkeer wordt binnen 24 uur ontvangen",
    "Confirm_recharge": "Opladen bevestigen",
    "scan": "Betaling scannen",
    "Paid": "Betaald",
    "Time": "Oplaadtijd",
    "Unpaid": "Niet betaald",
    "Operation": "Werking",
    "Connecting_Devices": "Draagcapaciteit",
    "Recharge_reminder": "Herinnering opladen",
    "scanComplete": "Scannen om betaling te voltooien",
    "unknown": "Onbekend",
    "rechargeChannel": "Oplaadmethode:",
    "Signal": "Signaalwaarde",
    "Plant": "Naam van de centrale",
    "rechargeDiscount": "Kortingsbedrag:",
    "expired": "Verlopen",
    "load": "Draagcapaciteit",
    "Recharge_List": "Oplaadlijst",
    "ccid": "Nummer stroomkaart voor gegevensverzamelaars",
    "Order_Number": "Ordernummer",
    "Package_type": "Pakkettype",
    "Recharge_record": "Oplaadrecord",
    "DataloggerName": "Alias",
    "Recharging": "Opladen",
    "Recharge_Selected": "Opladen",
    "rechargeErr": "Selecteer een gegevensverzamelaar met dezelfde laadcapaciteit",
    "rechargePrice": "Oplaadbaarheid:",
    "abroad": "in het buitenland",
    "normal": "Normaal",
    "previous": "Terugkeer",
    "CCID": "Verkeerskaartnummer",
    "CCID_time": "Vervaltijd van de verkeerskaart",
    "serial_number": "Serienummer",
    "Activation_Time": "Activatietijd",
    "confirm": "Bevestigen",
    "Recharge_status": "Oplaadstatus",
    "Recharge_now": "Nu opladen",
    "Content_warning": "Beste gebruiker, hallo! Er is ontdekt dat de verkeerskaart van het apparaat dat u gebruikt op het punt staat te vervallen. Als deze niet tijdig wordt opgeladen, zal de verkeerskaart worden geannuleerd door de operator en kan deze niet meer worden gebruikt. Om uw normaal gebruik niet te beïnvloeden, laad u de apparaten in de alarmstatus tijdig op!",
    "Recharge_fail": "Opladen mislukt",
    "rechargePackage": "Oplaadpakket:",
    "rechargeSuc": "Betaling succesvol",
    "pn": "PN-nummer van gegevensverzamelaar",
    "Tips": "Prompt",
    "Recharge_successful": "Opgeladen met succes",
    'Recharge_tip6': 'Er zijn kaarten die het opladen niet ondersteunen,Neem contact op met de beheerder',
    'area_domestic': 'Chinees vasteland',
    'area_abroad': 'internationaal',
        'remedy_title': 'Oplaadorder herstellen',
        'upload_tip': 'Vriendelijke herinnering: Het bestandsformaat voor uploaden is .txt'
  },
  "auxiliary": {
    "chartSupplement": "Reële grafiek",
    "auxiliaryFunction": "Hulpfuncties",
    "realChart": "Na het openen toont de grafiek echte gegevens."
  },
  "rate": {
    "cancel": "Annuleren",
    "buy_Rates": "Aankoopprijs voor elektriciteit：",
    "device_status": "Apparaatstatus",
    "generate_Rates": "Elektriciteitsopwekkingspercentage：",
    "edit": "Bewerken",
    "Income_currencys": "Ontvangstvaluta:",
    "sell_Rates": "Verkooptarief voor elektriciteit：",
    "datalogger_pns": "PN-gegevensverzamelaar:",
    "resetSuc": "Reset succesvol",
    "sell_Rate": "Verkooptarief voor elektriciteit",
    "generate_Rate": "Elektriciteitsopwekkingspercentage",
    "modifySuc": "Met succes gewijzigd",
    "confirm": "Bevestigen",
    "buy_Rate": "Aankoopprijs voor elektriciteit",
    "rate": "Tarief",
    "rate_list": "Prijslijst",
    "operating": "Werking",
    "Income_currency": "Ontvangstvaluta",
    "datalogger_name": "Naam gegevensverzamelaar",
    "datalogger_pn": "PN-gegevensverzamelaar",
    "unbindSuc": "Koppeling succesvol losmaken",
    "status": "Staat"
  },
  "intro": {
    "step_operate_1": "Heldere lay-out van apparaatinformatie",
    "step_operate_2": "Nadat u het apparaat hebt geselecteerd waarover u meer wilt weten, kunt u snel bladeren door het energiestroomdiagram van het apparaat, apparaatinformatie, gegevensgrafieken, parameteranalyse, gegevensdetails en alarminformatie.",
    "step_device_10": "Handig voor u om het apparaat te vinden waar u om geeft.",
    "step_project_5": "Nieuw, Bewerken, Verwijderen",
    "step_project_4": "Functies en apparatuur worden per project beheerd. Gebruikers kunnen uitvoeren",
    "slider_quite": "Opstarten afsluiten",
    "step_project_3": "Projectbeheer",
    "step_project_2": "Toevoegen",
    "step_project_1": "Beheersapparatuur voor het nieuwe systeem",
    "step_device_6": "Wanneer u op het apparaat bent, kunt u op Volg klikken,",
    "step_device_7": "Na het volgen",
    "step_device_8": "Apparatuur kan worden gebruikt als",
    "slider_next": "Volgende stap",
    "step_device_9": "Topping",
    "new_guide": "Beginnersgids",
    "gaa_msg": "Alarmherinnering",
    "step_device_1": "Vind snel het apparaat dat u volgt",
    "step_device_2": "Toevoegen",
    "step_device_3": "Let op apparaten",
    "slider_enter": "De nieuwe versie invoeren",
    "step_device_4": "Functie,",
    "step_device_5": "Muiszwever",
    "sys_msg": "Systeemberichten",
    "step_mode_3": "Lijst of kaart",
    "step_mode_4": "Presenteer in het formulier en kies de presentatiemethode volgens uw situatie.",
    "step_mode_1": "Kies uw favoriete apparaatlijststijl",
    "step_mode_2": "De apparaatlijst is toegankelijk via",
    "slider_pre": "Vorige stap",
        "unbind_tips": "Het apparaat is niet gekoppeld aan een eigenaar, koppel eerst de eigenaar",
    "device_code1": "Apparaatcode"
  },
  "alarm": {
    "Alarm_Msg": "Nieuw nieuws",
    "Alarm_Event": "Alarmgebeurtenis",
    "Intro_Msg": "Beginnersgids",
    "Alarm_Status": "Verwerkingsstatus",
    "alarmNum": "Aantal alarmen",
    "alrmDes": "Filterherinneringsbeschrijving",
    "deviceFilter": "Filterapparatuur",
    "tips": "Prompt",
    "Device_PN": "PN-nummer van gegevensverzamelaar",
    "Battery": "Batterij",
    "Alarm_Type": "Alarmtype",
    "warning": "Alarm",
    "device_address": "Apparaatadres",
    "details": "Details",
    "Camera": "Camera",
    "deviceType": "Type apparatuur",
    "curSelected": "Momenteel geselecteerd",
    "Status": "Staat",
    "all": "Alle",
    "untreated": "Niet verwerkt",
    "alrmType": "Alarmtypen filteren",
    "delete_alarm": "Weet je zeker dat je dit alarm wilt verwijderen?",
    "Delete_selected": "Geselecteerde verwijderen",
    "Microinverter": "Micro-omvormer",
    "faultTitle": "Aantal fouten in de afgelopen zeven dagen",
    "warningTitle": "Aantal alarmen in de afgelopen zeven dagen",
    "alarmDevice": "Apparaat-informatie",
    "Prevent_arcing_island": "Antieilandbeveiliging",
    "device_Warning": "Alarm voor apparatuur",
    "Occurrence_time": "Tijd van optreden",
    "device_Error": "Fout in de apparatuur",
    "Alarm_Message": "Uw",
    "Alarm_List": "Alarmlijst",
    "alarmStatus": "Statusstatistieken voor alarmverwerking",
    "combining_manifolds": "Combinerdoos",
    "allAlarm": "Totaal aantal alarmgebeurtenissen",
    "Device_Name": "Apparaatnaam",
    "Device_SN": "Apparaat SN",
    "Today_Alarm": "Aantal alarmen vandaag",
    "Alarm_Read": "U hebt alle alarmmeldingen gelezen",
    "Close": "Sluiten",
    "alarmDetails": "Alarmdetails",
    "device_alias": "Apparaataliassen",
    "Alarm_data": "Er is momenteel geen laatste nieuws!",
    "ruleManage": "Beheer van alarmfilterregels",
    "device_Fault": "Storing van apparatuur",
    "deletes": "Verwijderen",
    "User": "Gebruiker",
    "Cancel": "Annuleren",
    "timeSlot": "Tijdsperiode",
    "faultNum": "Aantal fouten",
    "Confirm": "Bevestigen",
    "ruleNew": "Regels toevoegen",
    "Alarm_Describe": "Alarmbeschrijving",
    "Operation": "Werking",
    "storage": "Energieopslagmachine",
    "alarmInfo": "Alarmsituatie",
    "error": "Fout",
    "Alarm_Message1": "Apparaat verschijnt",
    "offline": "Off-line",
    "Plant": "Aangesloten energiecentrale",
    "clearHistory": "Geschiedenis wissen",
    "ruleName": "Regelnaam",
    "Charger": "Oplader",
    "Alarm_Code": "Alarmcodering",
    "more": "Meer",
    "Device_Type": "Type apparatuur",
    "endtime": "Eindtijd",
    "fault": "Fout",
    "monitor": "Milieumonitoringsinstrument",
    "inverter": "Omvormer",
    "filterHistory": "Filtergeschiedenis",
    "processed": "Verwerkt",
    "_Data": "Gegevens",
    "smart_meters": "Slimme meter",
    "deleted_successfully": "Alarm succesvol verwijderd!",
    "view": "zie",
    "back": "Terug",
    "exportArchive": "Gearchiveerde alarm exporteren",
    "archiveRecord": "Archief",
    "archiveTip": "De lijst bevat alle onverwerkte alarmen en verwerkte records binnen 7 dagen"
  },
  "plantCode": {
    "successfulApplication": "Volg uw telefoon- of e-mailgegevens en wij zullen u zo snel mogelijk antwoorden.",
    "goRegister": "Ga naar registratie",
    "haveDevice": "Als u al een apparaat hebt, kunt u zich registreren en inloggen om het te gebruiken",
    "code_is_required": "Ervaringscode kan niet leeg zijn",
    "useDemo": "Heb je nog geen uitnodigingscode? Uitnodigingscode wordt alleen gebruikt voor demonstratie van functies",
    "pleaseName": "Voer uw naam in",
    "PleaseNumber": "Vul uw telefoonnummer in",
    "codeApplication": "Aanvraag ervaringscode",
    "pleaseCode": "Voer de uitnodigingscode in",
    "PleaseEmail": "Vul uw e-mailadres in",
    "PleaseCompanyName": "Voer de bedrijfsnaam in",
    "reasonNotEmpty": "De reden voor de aanvraag kan niet leeg zijn",
    "applyNow": "Nu aanvragen",
    "PleaseApplication": "Beschrijf de reden van uw aanvraag",
    "PleaseCompanyAddress": "Voer het bedrijfsadres in"
  },
  "firmware": {
    "Firmware_limit_format": "Alleen .bin, .hex en .s19 bestandsformaten zijn toegestaan",
    "Firmware_upload_fail": "Uploaden mislukt, probeer het opnieuw!",
    "Firmware_upload_failTip": "Uploaden mislukt",
    "Firmware_limit1": "U kunt maximaal",
    "Firmware_limit2": "bestanden",
    "Firmware_limit3": "firmware",
    "Firmware_limitM": "Individuele firmware-bestandsgrootte mag niet groter zijn dan",
    "cancel": "Annuleren",
    "Select_file": "Bestand selecteren",
    "Upload1": "Bestanden uploaden",
    "Size": "Firmware grootte (KB)",
    "Firmware_desrc": "Firmware Beschrijving",
    "upgrade_quit1": "Uitzondering upgrade, beëindigd!",
    "deleteSuc": "Succesvol verwijderd",
    "Upload": "Upload firmware",
    "del_firmware": "Firmware verwijderen",
    "Upload_firmware": "Upload firmware",
    "Operation": "Werking",
    "downloadFirmware": "Download",
    "tips": "Prompt",
    "deleteFirmware": "verwijderen",
    "Firmware_Version": "Versienummer",
    "Firmware_List": "Firmware beheer",
    "limit1": "Alleen bestanden in het \"xlsx\" formaat kunnen worden geüpload",
    "limit2": "Vriendelijke herinnering: De kolom A van het geüploade bestand is de PN voor gegevensverzamelaar en de kolom B is de alias voor gegevensverzamelaar. Er is geen behoefte aan een titel, zoals in de volgende afbeelding wordt weergegeven.",
    "limit": "Alleen bestanden in de formaten \". bin\" en \". hex\" kunnen worden geüpload, en de grootte mag 8MB niet overschrijden",
    "limit0": "Alleen bestanden in de formaten \". bin\" en \". hex\" en \". s19\"  kunnen worden geüpload, en de grootte mag 8MB niet overschrijden",
    "FailedCancelUpgrade": "Upgrade annuleren mislukt",
    "Firmware_Lists": "Firmware lijst",
    "uploadTips": "Upload het firmware bestand",
    "limit3": "Succesvol toegevoegd",
    "Upload_Time": "Uploadtijd",
    "Add_Firmware": "Firmware toevoegen",
    "upgrading1": "Verbinding upgraden, wacht alstublieft",
    "Firmware_Name": "Firmware naam",
    "upgrading": "Verbetering",
    "editFirmware": "Bewerken",
    "Firmware_description": "Firmware Beschrijving:",
    "confirm": "Bevestigen",
    "upgrade_quit8": "Uitzondering upgraden",
    "upgrade_quit7": "Upgrade mislukt",
    "noRecord": "Geen record",
    "upgrade_quit6": "Upgrade annuleren",
    "UploadTitle": "Upload batchbestanden",
    "enter_content": "Voer inhoud in",
    "upgrade_quit5": "Niet in upgrade",
    "upgrade_quit4": "Upgrade handmatig geannuleerd",
    "upgrade_quit3": "Upgrade succesvol",
    "delete_firmware": "Weet u zeker dat u deze firmware wilt verwijderen?",
    "upgrade_quit2": "Upgrade mislukt. Probeer het later opnieuw!",
    "updateCompleted": "Upgrade voltooid",
    "firmware_upgrade": "Firmware-update",
    "CancelUpgradeSuc": "Upgrade annuleren succesvol",
    "error1": "Alleen bestanden in de formaten \". bin\" en \". hex\". s19\" kunnen worden geüpload",
        "error2": " Please press LFU button",
    "CancelUpgradeSuc11": "Upgrade succesvol geannuleerd, wacht tot de datalogger is verbonden met de cloud voordat u upgradet",
    "upgrade_wait": "Upgrade wordt voorbereid, even geduld alstublieft (1–2 minuten)",
    "upgrade_wait1": "Upgrade-voorbereiding voltooid. Wacht tot de datalogger online is en start de upgrade-taak opnieuw",
    "colOffline": "Datalogger is offline",
		"colUpgrading": "Bezig met upgraden",
    "UpgradeStarting": "Upgrade starten, even geduld alstublieft...",
    "upgradeSq_fail": "Datalogger upgrade mislukt, probeer het later opnieuw!",
  },
  "map": {
    "datalogger": "Naam gegevensverzamelaar:",
    "address": "Apparaatadres:",
    "sn": "Apparaat SN:"
  },
  "group": {
    "cancel": "Annuleren",
    "Delete": "Verwijderen",
    "note": "Groepsnotities",
    "entername": "Voer een groepsnaam in",
    "deletegroup": "Groep verwijderen",
    "deletesuc": "De groep met succes verwijderd",
    "deleteConfirm": "Weet u zeker dat u deze groep wilt verwijderen?",
    "Operate": "Werking",
    "Group_name": "Groepsnaam",
    "Create_groups": "Groep aanmaken",
    "editsuc": "De groep succesvol bewerkt",
    "Group_name1": "Groepsnaam:",
    "confirm": "Bevestigen",
    "userCount": "Aantal gegroepeerde gebruikers",
    "Groups_list": "Groepslijst",
    "Edit_groups": "Groep bewerken",
    "creatsuc": "Succesvol aangemaakt groep",
    "finish": "Compleet",
    "note1": "Groepsnotities："
  },
  "controlDeviceErrCode": {
    "11": "Geen toestemming, neem contact op met de beheerder",
    "1": "Operatie mislukt. Controleer het apparaat en probeer het opnieuw!",
    "2": "Response timeout, probeer het opnieuw!",
    "3": "Systeemafwijking, neem contact op met de beheerder",
    "6": "Formaatfout, neem contact op met de beheerder",
    "8": "Geweigerd, neem contact op met de beheerder",
    "9": "Operatie wordt niet ondersteund, neem contact op met de beheerder",
    "263": "De huidige gegevensverzamelaar is offline. Probeer het opnieuw nadat het apparaat online is!"
  },
  "control":{
		"setting": "Verzenden",
    "TouSetting": "Systeemwerkingsmodus",
    "touCharge": "Laadprioriteit",
    "touPersonal": "Zelfverbruik",
    "touComplete": "Volledige Netinjectie",
    "touClipping": "Piekbewerking en Valleiopvulling",
    "touOffgrid": "Off-grid Toepassing",
    "confirmModeSwitch": "Modus Wisselen Bevestigen?",
    "modeSwitch": "Modus Wisselen",
    "startTime": "Starttijd",
    "endTime": "Eindtijd",
    "paramValue": "Selecteer Parameterwaarde",
    "Monday": "Maandag",
    "Tuesday": "Dinsdag",
    "Wednesday": "Woensdag",
    "Thursday": "Donderdag",
    "Friday": "Vrijdag",
    "Saturday": "Zaterdag",
    "Sunday": "Zondag",
    "syncSetDay": "Gesynchroniseerde Dagelijkse Verzending",
    "time": "Tijdsperiode 1",
    "time1": "Tijdsperiode 2",
    "time2": "Tijdsperiode 3",
    "time3": "Tijdsperiode 4",
    "time4": "Tijdsperiode 5",
    "time5": "Tijdsperiode 6",
    "setFail": "Verzenden Mislukt",
    "readFail": "Lezen Mislukt",
    "charge": "Opladen",
    "discharge": "Ontladen",
    "reading": "Succesvol Gelezen",
    "reading_loading": "Bezig met Lezen...",
    "pvMode": "Netinjectiemodus",
    "screenshot": "Screenshot"
	},
  "statistic": {
    "All": "Alle",
    "bc": "Gegevens laden",
    "normal": "Normaal",
    "other": "Andere",
    "totalRegion": "Alle regio's",
    "totalDevice": "Alle apparaten",
    "standby": "Standby",
    "regiontotal": "Totaal aantal regio's",
    "sy": "Apparaatgegevens",
    "pv": "Gegevens van fotovoltaïsche panelen",
    "active": "Actief",
    "allDevice": "Totaal aantal apparaten",
    "fault": "Fout",
    "generalAccount": "Eigenaren en gebruikers",
    "deviceStatus": "Apparaatstatus",
    "allAccount": "Alle gebruikers",
    "offline": "Off-line",
    "regionPercent": "Regionaal aandeel",
    "bt": "Batterijgegevens",
    "inactive": "Inactief",
    "Allstate": "Alle statussen",
    "adminAccount": "Dealergebruikers",
    "warning": "Waarschuwing",
    "userActivity": "Aantal gebruikersactiviteit",
    "dataUpdateTime": "Tijd van gegevensupdate",
    "gd": "Rastergegevens"
  },
  "settingalarm": {
    "Delete": "Verwijderen",
    "Add": "Toename",
    "cancel": "Annuleren",
    "Warning": "Alarm",
    "deletes": "Verwijderen",
    "Email": "Postvak",
    "Add_suc": "Succesvol toegevoegd push email!",
    "suredelete": "Weet je zeker dat je deze e-mail push wilt verwijderen?",
    "Yes": "Ja",
    "Fault": "Herinneren",
    "Operation": "Werking",
    "E_Mail": "E-mail:",
    "delete": "E-mail met succes verwijderd",
    "chosesstation": "Selecteer een centrale",
    "Receiving_Plant": "Opgezette centrales:",
    "Plant": "Geassocieerde elektriciteitscentrales",
    "Alarm_Type": "Alarmtype:",
    "create": "Vaststellen",
    "Monthly_Report": "Maandelijks rapportageformulier",
    "Add_Mailbox": "E-mailpush toevoegen",
    "No": "Nee",
    "Yearly_Report": "Jaarverslag",
    "edit": "Bewerken",
    "addEmails": "E-mail toevoegen",
    "Error": "Fout",
    "list": "Serienummer",
    "Email_Setting": "E-mailpush-instellingen",
    "Email_List": "Mailinglijst",
    "Receiving_Report": "Rapportenbeheer",
    "Alarm_Typetabel": "Alarmtype",
    "Delete_Mailbox": "E-mail verwijderen",
    "Daily_Report": "Dagelijks verslag"
  },
  "message": {
    "cancel": "Annuleren",
    "pwd_is_required": "Wachtwoord kan niet leeg zijn",
    "id_is_required": "Groep kan niet leeg zijn",
    "email_info": "Correct e-mailadres binnen 64-tekens",
    "delete_plant": "Kraftwerk verwijderen",
    "Exporting_the_report": "Uitvoerverslag",
    "length6_20": "Alleen 6 tot 20 letters, cijfers en onderstrepen kunnen worden ingevoerd",
    "length6_32": "Tussen 6 en 32 tekens in lengte",
    "nodata": "Geen gegevens",
    "oldPass_wrong": "Fout met oud wachtwoord, voer opnieuw in",
    "invitation_is_required": "Ervaringscode kan niet leeg zijn",
    "length2_32": "Tussen 2 en 32 tekens in lengte",
    "pwdSame": "De nieuwe en oude wachtwoorden kunnen niet hetzelfde zijn",
    "pn_is_required": "PN kan niet leeg zijn",
    "pwdAgain": "Voer het wachtwoord opnieuw in",
    "search": "Zoeken",
    "pwdNotsame": "De twee ingevoerde wachtwoorden komen niet overeen",
    "length2_64": "Tussen 2 en 64 tekens in lengte",
    "uname_is_required": "Account kan niet leeg zijn",
    "Logging_off": "Dit account wordt momenteel uitgelogd en kan niet worden aangemeld",
    "modify_plant": "De centrale aanpassen",
    "PN_info": "De lengte van het PN-nummer is 14- of 18-cijferig, waarbij de eerste letter een hoofdletter is en alleen hoofdletters en cijfers bevat.",
    "confpwd_is_required": "Wachtwoord bevestigen kan niet leeg zijn",
    "mobile_is_required": "Mobiel telefoonnummer kan niet leeg zijn",
    "email_is_required": "E-mail kan niet leeg zijn",
    "country_is_required": "Selecteer een land of regio",
  },
  "menu": {
    "datalogger": "Beheer van gegevensverzamelaars",
    "Total_user": "Totaal aantal gebruikers:",
    "customize": "Aangepaste instellingen",
    "setting": "Systeeminstellingen",
    "password": "Wachtwoord wijzigen",
    "rate": "Snelheidsinstelling",
    "recharge": "Opladen instellingen",
    "record": "Oplaadrecord",
    "alarm": "Alarmbeheer",
    "firmwarenew": "Firmware beheer",
    "adaptiveFirmware": "Adaptieve Firmware",
    "intelligenceUpgrade": "Slimme upgrade",
    "intelligenceUpgradeTitle": "Geen upgrade-pakket beschikbaar, neem contact op met de fabrikant",
    "intelligenceUpgradeTitle1": "Bevestig alstublieft of het apparaat een slimme upgrade moet ondergaan?",
    "intelligenceUpgradeTitle2": "Geen overeenkomend upgrade-pakket gevonden",
    "firmware": "Standaard upgrade firmware",
    "email": "E-mailinstellingen",
    "myDevice": "Mijn apparaat",
    "overview": "Overzicht",
    "functionalApplication": "Functionele toepassing",
    "mobile": "Telefooninstellingen",
    "pay": "Opladen van het verkeer",
    "personal": "Persoonlijke informatie",
    "alarmSetting": "Alarminstellingen",
    "home": "Startpagina",
    "browseAccount": "Beheer van subaccounts",
    "cloudsUpgrade": "Cloud upgrade",
    "strategy": "Lokale upgradestrategie",
    "basic": "Basisinformatie",
    "device": "Apparaatbeheer",
    "account": "Accountbeheer",

    "log": "Logboek van dataloggers",
    "actionLog": "Operatielogboek",
    "Manufacturer": "Beheer van de fabrikant",
    "datalogger_list": "Lijst van gegevensverzamelaars",
    "manufacturer_account": "Rekening van de fabrikant",
    "manufacturer_code": "Code van de fabrikant",
    "protocol_binding": "Verbinding van protocollen voor gegevensverzameling",
    "type_code": "Typecode van het apparaat voor gegevensverzameling",
    "protocol_change": "Wijziging van het protocol voor gegevensverzameling",
    "AIP_Interface": "API interface interface",
    "protocol_operation": "Protocolbewerkingstool",
    "recharge_management": "Oplaadbeheer",
    "device_management": "apparaatbeheer",
    "KEY_List": "Sleutellijst",
    "Protocol_instruction": "Beheer van protocolinstructie",
    "Raw_data": "Analyse van ruwe gegevens",
    "Recharge_remedy": "Herstel voor herlading",
    "device_function": "Functie apparatuurbeheer",
    "Password_maintenance": "Onderhoud van het wachtwoord van besturingselement",
  },
  "signup": {
    "too_simple": "Het wachtwoord is te eenvoudig, voer het opnieuw in",
    "code": "6-cijferige verificatiecode",
    "qiangdu": "Wachtwoordsterkte:",
    "di": "Zwak",
    "registered": "Register",
    "login": "Log nu in",
    "confirm_Pwdpl": "Wachtwoord bevestigen",
    "mobile_pl": "Mobiel telefoonnummer",
    "confirm_password": "Voer het wachtwoord opnieuw in",
    "emailSignup": "E-mailregistratie",
    "PN_pl": "PN-nummer",
    "zhong": "In",
    "email_form": "Binnen 64-tekens, gelieve nauwkeurig in te vullen om het wachtwoord op te halen",
    "usr": "2-32 tekens (alleen Chinees, letters en cijfers kunnen worden gebruikt om te onderstrepen) Accountnaam",
    "emailformat": "Voer het juiste e-mailadres in",
    "email": "Postvak",
    "pwdformat": "Fout in wachtwoordopmaak, 6-32 tekens (alleen cijfers, letters en onderstrepen kunnen worden gebruikt)",
    "usrformat": "Fout in accountopmaak, 2-32 tekens (alleen Chinees, letters en cijfers kunnen worden gebruikt voor onderstrepen)",
    "email_pl": "E-mailadres",
    "pwd_pl": "Wachtwoord",
    "Byte_2": "Tekenen",
    "pnformat": "PN nummeropmaak fout, 14 of 18 cijfers (alleen cijfers en letters kunnen worden gebruikt)",
    "Byte_1": "Ingevoerd",
    "phoneSignup": "Mobiele registratie",
    "mobileformat1": "Voer het juiste telefoonnummer in",
    "mobileformat": "Fout bij het formatteren van mobiele telefoonnummers (6-32)",
    "qiang": "Sterk",
    "code_pl": "Verificatiecode",
    "confirm_pl": "Voer het wachtwoord opnieuw in",
    "signup": "Register",
    "phone": "Mobiele telefoon",
    "success": "Login was succesvol",
    "usr_pl": "Gebruikersnaam",
    "phone_form": "Binnen 32-tekens, gelieve nauwkeurig in te vullen om het wachtwoord op te halen",
    "Register_account": "Registratie van de rekening",
    "existing_account": "Bestaande rekening?",
    "pwd": "6-32 tekens (cijfers, letters, onderstrepen), hoofdlettergevoelig",
    "pn": "14 of 18 tekens (alleen cijfers en letters kunnen worden gebruikt)",
    "country_pl": "Land of regio",
  },
  "version": {
    "to_new": "Terug naar nieuwe versie",
    "to_old": "Terug naar vorige versie",
    "custom_theme": "Aangepast thema",
    "default_theme": "Standaard thema",
    "default_node": "Standaard knooppunt"
  },
  "createPlant": {
    "fileExceed": "Bestand te groot",
    "Control_settings": "Instellingen van de energieopslagmachine",
    "basic_settings": "Basisinstellingen",
    "Basic_setting": "Basisinstellingen",
    "select_all": "Alles selecteren",
    "pv": "PV",
    "gd": "Net",
    "bt": "Accu",
    "bc": "Belasting",
    "sy": "Systeem",
    "eg": "Generator",
    "hl": "HuishoudelijkeBelasting",
    "System_settings": "Systeeminstellingen",
    "Grid_settings": "Rasterinstellingen",
    "Solar_settings": "Zonneinstellingen",
    "imageLimit": "De afbeelding ondersteunt alleen jpg- en png-formaten en de maximale grootte mag 8M niet overschrijden",
    "Load_setting": "Laad-instelling",
    "Standard_setting": "Standaardinstellingen",
    "other_settings": "Andere instellingen",
    "Advanced_setting": "Geavanceerde instelling",
    "Battery_settings": "Batterijinstellingen",
    "Battery_settingsTT": "Algemene batterijinstellingen",
    "Battery_settings1": "Batterijpakket 1",
		"Battery_settings2": "Batterijpakket 2",
    "Work_settings2": "Stel systeemwerkstatus in",
    "Machine_settings2": "Schakel machinestand-byfunctie in",
    "Clear_settings2": "Fout wissen",
    "uploadSuccess": "Upload succesvol"
  },
  "upgradeManagement": {
    "cancel": "Annuleren",
    "eidt_success": "Met succes bewerkt",
    "delete_success": "Geslaagd geannuleerd",
    "edit_firmware": "Firmware bewerken",
    "delete_success1": "Succesvol verwijderd",
    "download_firmware": "Firmware downloaden",
    "upgrade_file_format1": "Kan alleen uploaden in .bin/.hex formaat",
    "upgrade_file_format2": "Het bestand mag 1MB niet overschrijden",
    "Upload": "Upload firmware",
    "Firmware_Version": "Versienummer",
    "firmwareName_empty": "Firmware naam kan niet leeg zijn",
    "confirm": "Bevestigen",
    "upgrade_file_format": "Kan alleen uploaden in .bin/.hex formaat, kan niet groter zijn dan 1MB",
    "firmware_name": "Naam firmwarepakket",
    "Remarks": "Firmware Beschrijving",
    "please_upgrade": "Selecteer het uploadbestand",
    "download_firmware_prompt": "Weet u zeker dat u deze firmware wilt downloaden?",
    "upload_firmware": "Upload firmware",
    "create": "Vaststellen",
    "please_input": "Gelieve in te voeren",
    "firmwareVersion_empty": "Versienummer kan niet leeg zijn",
    "download_success": "Downloaden",
    "delete_desc": "Na verwijdering is het niet mogelijk om te herstellen en de upgradestrategie die voor deze firmware is geselecteerd, kan het apparaat niet upgraden",
    "upgrade_success": "Met succes geüploade firmware",
    "download_exception": "Download uitzondering, probeer het later opnieuw",
    "upload_result": "Uploadresultaat",
  },
  "401": {
    "goback": "Laatste pagina",
    "gohome": "Startpagina",
    "oops": "Verdomme!",
    "noAuth": "U heeft geen toestemming om deze pagina te bezoeken."
  },
  "errCode": {
    "271": "Geen wijzigingen",
    "272": "Binding dupliceren",
    "273": "Het toevoegen van gegevensverzamelaars van andere fabrikanten wordt niet ondersteund",
    "352": "Geen firmware",
    "353": "Geen protocol",
    "276": "Eigenaren van elektriciteitscentrales die geen ondersteuning bieden voor het verplaatsen van gegevensverzamelaars van andere fabrikanten",
    "512": "Mismatch met SMS-verificatiecode",
    "513": "SMS-verificatiecode timeout",
    "514": "Telefoonnummer/e-mail niet gebonden",
    "515": "Telefoonnummer/e-mail mismatch",
    "516": "Naam kan niet dezelfde naam hebben",
    "517": "Er zijn nog steeds dataverzamelaars onder de gebruiker of krachtcentrale",
    "518": "De gebruiker heeft nog ondergeschikte gebruikers",
    "519": "Herhaling van gebruikersnaam",
    "10": "Authenticatie mislukt, logt u opnieuw in",
    "11": "Ongeoorloofde handelingen",
    "12": "Geen record",
    "13": "Overschrijding van de grenswaarde",
    "14": "Herhalingsoperatie",
    "15": "Geen fabriekssleutel gevonden",
    "16": "Wachtwoord fout",
    "17": "Fout in wachtwoordopmaak",
    "18": "Het telefoonnummer is al gebonden. Wijzig het telefoonnummer of maak het los",
    "1792": "Gegevensverzamelaars moeten allemaal toebehoren aan deze beheerder",
    "19": "Fout bij het opmaken van telefoonnummers (6<=cijferlengte<32)",
    "1031": "De gebruiker is niet aangemaakt door deze beheerder",
    "1030": "Ongeldige GPRS-kaart",
    "0": "Normaal, geen fouten",
    "1029": "Dubbel gegevensverzamelnummer",
    "1": "Mislukken",
    "1028": "Niet-ondersteunde oplaadmethode",
    "288": "Geen camera",
    "2": "Timeout, systeem bezet. Probeer het later opnieuw",
    "1027": "De superieure gebruiker moet een beheerder of apparaatfabrikant zijn",
    "520": "PN-nummer is dupliceerd",
    "3": "Systeemafwijking, neem contact op met de beheerder",
    "1026": "Alleen fabrikanten van apparaten worden ondersteund",
    "521": "De gegevensverzamelaar behoort niet tot deze gebruiker",
    "4": "Voer geen speciale tekens in (handtekeningen die niet kunnen worden geverifieerd)",
    "1025": "Alleen beheerders worden ondersteund",
    "522": "Gegevensverzameling bestaat al",
    "368": "Geen rol",
    "5": "Zoutwaarde fout, niet gebruikt volgens regels",
    "1024": "Alleen eigenaren van elektriciteitscentrales ondersteunen",
    "523": "Geen vieweraccount",
    "369": "Geen gebruikersgroepen",
    "6": "Fout in de parameteropmaak",
    "7": "Ontbrekende noodzakelijke parameters",
    "525": "De verificatiecode is verzonden. Probeer het later opnieuw",
    "528": "Deze rol is al gebonden aan een gebruiker en kan niet worden verwijderd",
    "8": "Platform afwijzen",
    "768": "Er zijn geen optionele velden in het protocol",
    "9": "Niet-ondersteunde bewerking",
    "20": "Fout in e-mailformaat (6<=e-maillengte<64 en met bsymbol)",
    "21": "Foute gebruikersnaam opmaak (2<=gebruikersnaam lengte<32)",
    "22": "Fout bij opmaak van bedrijfsnaam",
    "23": "De code van de fabrikant is ongeldig. Controleer of de code correct is ingevuld",
    "24": "Herhaling van gebruikersnaam",
    "25": "Het account is uitgeschakeld. Neem contact op met de beheerder",
    "26": "De e-mail is gebonden. Wijzig de e-mail of maak de koppeling los",
    "27": "Het account is geannuleerd. Neem contact op met de beheerder",
    "1042": "Ongeldige CCID",
    "1041": "De sleutel is verlopen of kan niet worden gevonden",
    "370": "Geen groepering van elektriciteitscentrales",
    "371": "Geen GPRS-laadpakket voor verkeer",
    "372": "Geen GPRS-verkeersoplaadorders",
    "772": "De verzamelaar is gebonden.",
    "256": "Geen gegevens",
    "257": "Geen gegevens",
    "258": "Geen apparaat",
    "259": "Ongeldig PN nummer, controleer of het PN nummer correct is",
    "260": "Geen centrale",
    "261": "Kan gebruiker niet vinden",
    "262": "Apparaat is offline",
    "384": "Fout bij invoer van verificatiecode",
    "263": "De gegevensverzamelaar is offline gezet",
    "385": "Geen apparaat_ Token",
    "264": "Geen apparaatalarm",
    "386": "Geen informatie over apparaatconfiguratie",
    "265": "Geen omgevingsdetector",
    "387": "Talloze soorten verzamelaars"
  },
  "report": {
    "cancel": "Annuleren",
    "select_date": "Selecteer een datum",
    "Yearly_Report": "Jaarverslag",
    "Export_report": "Uitvoerverslag",
    "Export_alarm": "Alarmen exporteren",
    "Report_date": "Datum van het rapport:",
    "no_deAlarm": "Er zijn geen apparaatalarmen opgetreden in de afgelopen maand",
    "Report_date1": "Opmerking: Het bereik van exportdata mag 31 dagen niet overschrijden",
    "Total_report": "Algemeen verslag",
    "Subscribe_report": "Abonneren op rapporten",
    "customize": "Op maat",
    "all_reports": "Alles exporteren",
    "current": "Dit moment",
    "download": "Downloaden in uitvoering, alstublieft wacht",
    "Report_type": "Rapporttype:",
    "Export": "Export",
    "Daily_report": "Dagelijks verslag",
    "to": "Aan",
    "Batch_export": "Batch export",
    "Monthly_report": "Maandelijks rapportageformulier",
    "End_date": "Einddatum",
    "start_date": "Beginddatum"
  },
  "404": {
    "notFound": "De pagina kan niet worden gevonden"
  },
  "retrieve": {
    "Verification_code": "Verificatiecode",
    "passwordPhone": "Geen telefoonnummer gebonden",
    "Email": "Postvak",
    "enter_code": "Voer de verificatiecode in",
    "re-register": "Log opnieuw in",
    "login": "Inloggen",
    "Reset_successfully": "Wachtwoord reset succesvol, onthoud uw nieuwe wachtwoord",
    "Retrieve_passwordEmail": "Wachtwoord ophalen via e-mail",
    "bound_mobile": "Voer het gebonden telefoonnummer in",
    "Retrieve_password": "Wachtwoord ophalen",
    "passwordPhone1": "Mismatch met telefoonnummer",
    "Confirmloginpassword": "Nieuw login wachtwoord bevestigen",
    "Get_codeSucc": "Met succes verkregen verificatiecode",
    "New_password": "Nieuw login wachtwoord",
    "email_first": "Vul eerst de e-mail in",
    "code_1minute": "De verificatiecode is verzonden naar uw telefoon en is binnen een minuut geldig",
    "finish": "Compleet",
    "Retrieve_passwordPhone": "Telefoonwachtwoord ophalen",
    "bound_email": "Vul de bindende e-mail in",
    "Email_verification": "E-mailverificatie",
    "step4": "Stap 4",
    "code_5minutes": "De verificatiecode is verzonden naar uw e-mail en is binnen vijf minuten geldig",
    "Getting_progress": "Ontvangen, wacht alsjeblieft!",
    "Confirm_password": "Nieuw wachtwoord bevestigen",
    "reset_Password": "Wachtwoord opnieuw instellen",
    "enter_name": "Voer één gebruikersnaam in",
    "mobile_first": "Vul eerst uw telefoonnummer in",
    "Phone_verification": "Mobiele verificatie",
    "Reset_passwordSuc": "Wachtwoord resetten succesvol",
    "step2": "Stap 2",
    "step3": "Stap 3",
    "signup": "Register",
    "step1": "Stap 1",
    "confirm": "Bevestigen",
    "account_password": "Voer het account in waarvoor u het wachtwoord moet ophalen",
    "Change_one": "Verander een",
    "Obtain_code": "Verkrijgen",
    "Incorrect_code": "Foute verificatiecode",
    "new_password": "Nieuw login wachtwoord",
    "passwordEmail1": "Mismatch per e-mail",
    "passwordEmail": "Ongebonden postvak",
    "Newloginpassword": "Nieuw login wachtwoord",
    "phone_number": "Mobiel telefoonnummer",
    "Verify_identidy": "Identiteit verifiëren",
    "Enter_account": "Account invoeren",
    "Con_password": "Nieuw wachtwoord bevestigen",
    "username": "Gebruikersnaam"
  },
  "header": {
    "log_out": "Verlaat het systeem",
    "change_password": "Wachtwoord wijzigen",
    "pnAndSN": "PN/SN",
    "plant_owner": "Eigenaar van een elektriciteitscentrale",
    "operating_manual": "Bedieningshandleiding",
    "bind_email": "Bind e-mail",
    "bind_mobile": "Verbind telefoon",
    "skin": "Huid wisselen",
    "shopping_mall": "Winkelcentrum",
    "pnAndAlias": "PN-nummer van gegevensverzamelaar/naam van gegevensverzamelaar",
    "personal_infor": "Persoonlijke informatie",
    "pleaseSelect": "Selecteer",
    "language": "Taalinstellingen",
    "pleaseSelect1": "Selecteer een tijdstip"
  },
  "basic": {
    "backTo": "Terugkeer",
    "Change_email": "E-mail wijzigen",
    "Email": "E-mail:",
    "uploadAvatar": "Avatar vervangen",
    "editNickname": "Bijnaam wijzigen",
    "bindPhone": "Telefoonbinding",
    "bindPhoneTip": "Stel een mobiele telefoon in die kan inloggen en wachtwoorden kan ophalen en meldingen van het systeem kan ontvangen.",
    "changePwdSuc": "Wachtwoord resetten succesvol",
    "accountSecurity": "Rekeningszekerheid",
    "modifySuc": "Met succes gewijzigd!",
    "Personal_info": "Wijziging van de informatie",
    "bindPhoneTipAfter": "U kunt inloggen en uw wachtwoord ophalen en meldingen van het systeem ontvangen.",
    "Nickname": "Bijnaam:",
    "bindEmailTipBefore": "Gebonden postvak:",
    "email_code": "De verificatiecode is verzonden naar uw e-mail, controleer deze zorgvuldig",
    "unbinding_Em": "Na het loskoppelen kan het wachtwoord niet worden opgehaald met deze e-mail!",
    "Bind_phone": "Verbind telefoon",
    "After_bindingPh": "Na het binden van de telefoon, kan het wachtwoord worden opgehaald via de telefoon",
    "code_frequently": "De verificatiecode wordt regelmatig verzonden. Probeer het later opnieuw",
    "finished": "compleet",
    "Ple_Nickname": "Voer een bijnaam in",
    "bindRes": "Verbindende resultaten",
    "changeBtn": "wijzigen",
    "setMobile": "Vast mobiel telefoonnummer",
    "Ple_email": "Voer de e-mail in om aan te binden",
    "unbind_Ph": "Weet je zeker dat je je telefoonnummer loskoppelt?",
    "Bind_email": "Bind e-mail",
    "re_enter": "Ophalen",
    "Obtain_code": "Verificatiecode verkrijgen",
    "Change_phone": "Telefoon vervangen",
    "noHanzi": "Het wachtwoord kan geen Chinese tekens bevatten",
    "setNickname": "Bijnaam instellen",
    "suc_em": "Succesvol gebonden e-mail",
    "Save": "Bewaren",
    "basic": "Persoonlijke informatie",
    "bindEmail": "E-mailbinding",
    "mobile_code": "De verificatiecode is verzonden naar uw telefoon, controleer deze zorgvuldig",
    "code": "Verificatiecode:",
    "setEmail1": "Bind e-mail",
    "unbind_Em": "Weet je zeker dat je de e-mail loskoppelt?",
    "Untie_phone": "Telefoon ontkoppelen",
    "basicInfo": "Basisinformatie",
    "changePwd": "Wachtwoord wijzigen",
    "unbinding_Ph": "Na het loskoppelen kan de telefoon het wachtwoord niet ophalen!",
    "bindPhoneTipBefore": "Gebonden telefoon:",
    "Ple_phone": "Voer het telefoonnummer in dat u wilt binden",
    "Email1": "E-mail",
    "Email2": "E-mail:",
    "Select_all": "Alles terugzetten",
    "retry": "Opnieuw proberen",
    "editMobile": "Telefoonnummer wijzigen",
    "Ple_code": "Voer de verificatiecode in",
    "editEmail": "E-mailadres wijzigen",
    "User_name1": "Gebruikersnaam",
    "personalCenter": "Accountinstellingen",
    "changePwdTip": "Een wachtwoord met een hoge beveiliging kan het account veiliger maken. Wij raden u aan om regelmatig uw wachtwoord te wijzigen en een wachtwoord van 6 tot 32 cijfers in te stellen.",
    "suc_ph": "Geslaagd telefoonnummer",
    "changeRes": "Resultaten wijzigen",
    "bindEmailTip": "Stel een e-mail in om in te loggen en wachtwoorden op te halen en meldingen van het systeem te ontvangen.",
    "Unbind_email": "E-mail ontkoppelen",
    "Mobile": "Mobiel nummer:",
    "Avatar": "Gebruikersafbeelding",
    "Mobile1": "Mobiel telefoonnummer",
    "Nickname1": "Bijnaam",
    "User_name": "Gebruikersnaam:",
    "After_bindingEm": "Na het binden van de e-mail kan het wachtwoord worden opgehaald via de e-mail",
    "Nickname_length_tip": "Gebruikersbijnaam van 2 tot 32 bits"
  },
  "strategy": {
    "cancel": "Annuleren",
    "Not_upgraded": "Niet bijgewerkt",
    "strategy_number": "Aantal opgewaardeerde objecten",
    "force_upgrade": "Upgrade forceren",
    "strategyIntro": "Overzicht van het lokale upgradeproces",
    "message_baudrate": "Selecteer de bouwsnelheid",
    "In_effect": "In feite",
    "view": "Controle",
    "strategyUpgrade": "Strategielijst upgraden",
    "stategyStep9": "Status en resultaten van apparaatupgrades bekijken",
    "message_name": "Voer een beleidsnaam in",
    "cancel_strategy": "Beleid annuleren",
    "uprade_name": "Upgrade forceren",
    "stategyStep8": "Upgrade records bekijken",
    "edit_strategy": "Beleid bewerken",
    "stategyStep7": "Voeg een nieuwe strategie toe aan de lijst met upgradestrategieën, selecteer Firmware upgraden, stel de upgrademethode in en ga in werking, koppel het upgradeapparaat aan en genereer de upgradestrategie",
    "stategyStep6": "Upgrade strategie toevoegen",
    "message_desc": "Voer een beleidsbeschrijving in",
    "stategyStep5": "Nadat de strategie van kracht is, ontvangt de APP een upgradeherinnering en kan deze lokaal upgraden",
    "suggested_upgrade": "Voorgestelde upgrade",
    "stategyStep4": "APP lokale upgrade",
    "add_strategy": "Strategielijst upgraden",
    "stategyStep3": "Upload firmwareversiepakketbestanden in lokaal firmwarebeheer",
    "stategyStep2": "Nieuw firmwareversiepakket",
    "End_date": "Vervaldatum",
    "Upgrade_tip": "Selecteer het apparaat dat is gekoppeld aan het beleid",
    "edit": "Bewerken",
    "uprade_success": "Upgrade succesvol",
    "strategy_firmware": "Firmware bijwerken",
    "upgrade_remind": "Upgradeherinnering",
    "message_timezone": "Selecteer een tijdzone",
    "message_type": "Selecteer het firmware type",
    "go_back": "Terugkeer",
    "Upgrade_result": "Succesvol toegevoegd",
    "uprade_time": "Upgradetijd",
    "message_uprade_type": "Selecteer het type upgrade",
    "stategyDetail7": "Beleidsstatus",
    "message_firmware": "Selecteer firmware",
    "start_time": "Tijdstip van inwerkingtreding",
    "stategyDetail6": "Upgradevoortgang",
    "stategyDetail5": "Upgrademethode",
    "uprade_status": "Upgradestatus",
    "stategyDetail4": "Bouwsnelheid",
    "TOP": "Vorige stap",
    "completion_strategy": "Voltooiingsstrategie",
    "delete_firmware": "Weet u zeker dat u dit beleid wilt annuleren?",
    "stategyDetail9": "Vervaltijd",
    "Next": "Volgende stap",
    "stategyDetail8": "Tijdstip van inwerkingtreding",
    "strategy_desc": "Beleidsbeschrijving",
    "strategy_detail": "Strategiegegevens",
    "strategy_status": "Beleidsstatus",
    "Yes_started": "Opgewaardeerd",
    "strategy_baudrate": "Bouwsnelheid",
    "UpgFirmware": "Lokaal firmware beheer",
    "delete_desc": "Na annulering is het niet mogelijk om te herstellen en kan de geselecteerde upgradestrategie het apparaat niet waarschuwen om te upgraden",
    "strategy_name": "Beleidsnaam",
    "remind_desc": "Herinneringsbeschrijving",
    "strategy_search": "Beleidscode/Beleidsnaam",
    "uprade_type": "Upgrademethode",
    "uprade_result": "Resultaten upgraden",
    "associated_device": "Bijbehorende apparaten",
    "stategyDetail3": "Firmware type",
    "stategyDetail2": "Grootte firmwarepakket (KB)",
    "stategyDetail1": "Firmware bijwerken",
    "upgradeList": "Recordlijst upgraden",
    "message_time": "Selecteer een geldige tijd",
    "expired": "Verlopen",
    "strategyIntro1": "Beschrijving: Deze functiemodule is alleen voor Bluetooth lokale firmware-upgrade. Als u de firmware van apparaten zoals Wi-Fi of 4G wilt upgraden, gaat u naar [Apparaatbeheer Apparaatlijst Upgrade Operatie]",
    "uprade_name1": "Voorgestelde upgrade",
    "view_strategy": "Beleid weergeven",
    "strategy_code": "Beleidscodering",
    "upgrade_strategy_list": "Strategielijst upgraden",
    "start_date": "Ingangsdatum",
    "default_desc1": "Dit apparaat moet worden geüpgraded naar een hogere versie voordat het kan worden gebruikt. Klik op 'Upgrade forceren' om te upgraden. Koppel de Bluetooth-verbinding niet los en zorg voor een soepele netwerkwerking tijdens de upgrade.",
    "strategyInfor": "Informatie over het upgradebeleid",
    "policy_information": "Beleidsinformatie",
    "end_time": "Vervaltijd",
    "strategy_type": "Firmware type",
    "strategy_upgrade_search": "Apparaat SN/gegevensverzamelaar PN",
    "confirm": "Bevestigen",
    "strategy_time": "Effectieve tijd",
    "Not_started": "Niet gestart",
    "uprade_fail": "Upgrade mislukt",
    "stategyDetail": "Beleidsnaam",
    "default_desc": "Standaard beschrijving",
    "to": "Terugkeer",
    "limits":     "Tip: in het geüploade bestand moet kolom A het PN van de data-logger bevatten; een kopregel is niet nodig — zie het voorbeeld in de afbeelding hieronder.",
    "mueas":      "Updatestrategie",
    "upNum":      "Aantal te upgraden apparaten",
    "deletCL":    "Strategie verwijderen",
    "deletCL_TEST":"Weet u zeker dat u deze strategie wilt verwijderen?",
    "ONE_UP":     "Enkel apparaat upgraden",
    "MO_UP":      "Bulkapparaten upgraden",
    "MO_text": "Succesvol geïmporteerd",
"MO_tex1": "Gedupliceerd",
"MO_tex3": "Niet gevonden",
"MO_tex2": "Organisatie",
"MO_tex4": "Firmware wordt gebruikt in actief beleid, kan niet worden verwijderd",
  },
  "retrieveUser": {
    "accountInfo": "Accountinformatie",
    "pleasePn": "Voer het apparaat PN in",
    "forgetUser": "Account vergeten",
    "phone": "Het telefoonnummer dat aan uw account is gekoppeld is:",
    "Return_to_login": "Terug naar inloggen",
    "illustrate": "Als u uw account bent vergeten, kunt u accountinformatie vragen door het PN-nummer van elk apparaat in te voeren onder uw account, zodat u uw account kunt terugroepen!",
    "pnError": "De PN die u hebt ingevoerd is onjuist",
    "comfig": "Bevestigen",
    "pnErrorMsg": "Gegevensverzameling niet gevonden",
    "user": "Uw gebruikersnaam is",
    "email": "Het e-mailadres dat aan uw account is gekoppeld is:",
    "pn": "Voer de PN in van elk apparaat onder uw account"
  },
  "device": {
    "cancel": "Annuleren",
    "year": "Elektriciteitsverbruik van het lopende jaar",
    "deleteSuc": "Succesvol verwijderd",
    "pageSize": "Weergeven op huidige pagina",
    "noDataPlease": "Geen gegevens, selecteer de tijd opnieuw",
    "Battery_voltage": "Batterijspanning",
    "select_file": "Selecteer firmware",
    "confirm_deldte": "Weet je zeker dat je het verwijdert?",
    "brandDevice": "Apparatuur",
    "familyLoad": "Huishoudelijke belasting",
    "solar": "Zonne-energie",
    "clear_data": "Gegevens wissen",
    "universal_firmware": "Universele firmware",
    "select_brate": "Selecteer de bouwsnelheid",
    "Send_Command": "Opdrachtafgifte",
    "showParam": "Weergaveparameters",
    "gridPower": "Netstroom",
    "brand3": "Geïntegreerde machine voor energieopslag",
    "upgrade": "Batch upgrade",
    "brand2": "Omvormer",
    "In_Upgrading": "Het apparaat of de gegevensverzamelaar wordt al geüpgraded",
    "edit": "Bewerken",
    "brand1": "Off-grid omvormer",
    "brand0": "Andere energieopslagmachines",
    "analysis": "Parameteranalyse",
    "Cumulative_income": "Totale inkomsten uit energieopwekking",
    "pvPower": "Energieopwekking",
    "cur_thismonth": "Deze maand",
    "modify_alias": "Apparaat bewerken",
    "Device_sn": "Serienummer van apparatuur",
    "device_code": "Communicatieprotocol",
    "alternator": "Alternator",
    "detail": "Details bekijken",
    "charged": "Laadcapaciteit",
    "device": "Apparatuur",
    "cur_day": "Dag",
    "datalogger_pn": "PN-gegevensverzamelaar",
    "Equipment_agreement": "Apparaatprotocol",
    "loadPower": "Lastvermogen",
    "standby": "Standby",
    "timeSlot": "Tijdsperiode",
    "select_type": "Selecteer het firmware type",
    "alarmInfo": "Alarminformatie",
    "battery": "Batterij",
    "Successfully_modified": "Met succes gewijzigd",
    "offline": "Off-line",
    "default": "Default",
    "buyProfit_Today": "Huidige aankoopkosten van elektriciteit",
    "copy_val_no": "Kopiëren is mislukt",
    "Upgrading": "Upgrades in uitvoering, wacht alstublieft",
    "copy_val_yes": "Succesvol gekopieerd",
    "Send_fail": "Opdracht uitgeven mislukt",
    "control_firmware_bms": "BMS-firmware",
    "person_authority": "Eigenaarsautoriteit",
    "distribute": "Verdelen",
    "optionTitle": "Geselecteerd",
    "optionTitle1": "term",
    "optionTitle2": "De selectie van apparaatparameters mag 4 niet overschrijden",
    "optionTitle4": "De selectie van apparaatparameters mag 12 niet overschrijden",
    "optionTitle3": "Selecteer geen opties met meer dan twee verschillende eenheden",
    "clause": "Gegevens details",
    "debug_suc": "Debuggen succesvol",
    "set": "Ingesteld",
    "refresh": "Vernieuwen",
    "inverter": "Omvormer",
    "clear_val": "Opruimen",
    "protocolStatistic": "Statistieken van het communicatieprotocol",
    "dataloggerList": "Lijst met gegevensverzamelaars",
    "buyProfit_Total": "Totale kosten voor de aankoop van elektriciteit",
    "confirm": "Bevestigen",
    "queryUpgrade": "Upgrade van batchquery's",
    "device_cloudsUpgrade": "Apparaatcloud upgrade",
    "Debugfail": "Debuggen mislukt, apparaat is offline",
    "chart": "Datagrafiek",
    "Sn_deviceName": "SN / Apparaatnaam / PN / Gebruiker",
    "current_val": "Huidige waarde",
    "upFailDevice": "Apparaten die niet kunnen upgraden",
    "copy_val": "Kopie",
    "User_belong": "Gebruiker",
    "deviceName": "Apparaatnaam",
    "frequency": "Frequentie",
    "cloudUpgrade": "Cloud upgrade",
    "Device_pn": "Apparaat PN:",
    "generated": "Energieopwekking",
    "deviceList": "Apparaatlijst",
    "warning": "Waarschuwing",
    "device_address": "Apparaatadres",
    "energyFlow": "Energiestroomdiagram",
    "upgrade_brate": "Bouwsnelheid:",
    "batteryPower": "Batterijvermogen",
    "firmware_type": "Firmware type:",
    "add": "Toename",
    "dataTips": "Het huidige apparaat is offline en heeft geen real-time gegevens.",
    "upDevice": "Apparaat upgrade",
    "statistic": "Statistieken",
    "loadMore": "Meer laden",
    "firmware_package_message": "Selecteer firmware",
    "Please_parameter": "Selecteer een parameter",
    "Allthemachines": "Alle apparaten",
    "deviceNo": "Je hebt nog geen apparaat toegevoegd",
    "firmware_step_message": "Voer de startstappen in",
    "pro": "Project",
    "deviceInfo": "Apparaat-informatie",
    "moveSuc": "Met succes verplaatst",
    "month": "Huidige maand elektriciteitsverbruik",
    "return_content": "Retourneer inhoud:",
		"ownerShip": "Eigenaarswijziging",
    "oldOwner": "Vorige eigenaar:",
    "nweOwner": "Nieuwe eigenaar:",
    "loading": "Laden...",
    "moreLoading": "Scroll om meer te laden",
    "pleaseDate": "Selecteer een datum",
    "baudrate_message": "Selecteer de bouwsnelheid",
    "unfollow": "Volg annuleren",
    "upgradeProgress": "Huidige upgradevoortgang",
    "file_fist": "Selecteer eerst de firmware die u wilt upgraden",
    "device_model": "Model uitrusting",
    "followList": "Let op apparaten",
    "continueUpgrade": "Doorgaan met upgraden",
    "device_name": "Apparaatnaam",
    "Magnification": "Vergroting",
    "Today_income": "Dagelijkse inkomsten uit energieopwekking",
    "addUpgradeSuccess": "Succesvol toegevoegd",
    "numberRlues": "Voer het juiste aantal stappen in",
    "normal": "Normaal",
    "sold": "Verkoop van elektriciteit",
    "overview": "Statistisch overzicht",
    "coll_alias": "Alias voor gegevensverzamelaar",
    "device_upgradeStatus": "Upgradestatus",
    "relay": "Micro inversie",
    "consumption": "Belasting",
    "Check_all": "Alles controleren",
    "cur_month": "Maand",
    "noAuth": "Geen gelieerde gebruiker, geen toestemming om te bekijken",
    "step": "Start stappen:",
    "edit_control": "Apparaatbesturingsmachtigingen bewerken",
    "noDate": "Kan geen toekomstige datum selecteren",
    "device_upgrade": "Apparaatfirmware upgrade",
    "chosenParam": "Geselecteerde parameters",
    "updatefail": "Upgrade mislukt, collector is mogelijk offline of controleer of communicatie met collector normaal i",
    "device_pn": "PN-nummer",
    "administrator_cansee": "Geselecteerde machtiging vertegenwoordigt: zichtbaar voor beheerders, niet aangevinkt vertegenwoordigt onzichtbaar.",
    "Instruction": "Instructies:",
    "device_upgradeTime": "Upgradetijd",
    "Send_suc": "Opdracht met succes afgegeven",
    "Cancel_all": "Alles annuleren",
    "discharged": "Aflozingscapaciteit",
    "communication_firmware": "Communicatieversie firmware",
    "cur_today": "Vandaag",
    "deviceDebug": "Debugging van apparatuur",
    "generation": "Fotovoltaïsche panelen",
    "Datalogger_belong": "Aangesloten gegevensverzamelaar",
    "field": "Veldcontrole",
    "defaultUpgrade": "Standaard upgrade",
    "reset": "Reset",
    "person_cansee": "Geselecteerde machtiging vertegenwoordigt: zichtbaar voor de eigenaar, niet aangevinkt vertegenwoordigt onzichtbaar.",
    "device_alias": "Apparaatnaam:",
    "minSelect": "Ten minste één parameter moet worden gecontroleerd",
    "deviceUpgradeProgress": "Vooruitgang bij de upgrade van apparatuur",
    "maxSelect": "Maximaal 7 parameters kunnen worden gecontroleerd",
    "Output_table": "Uitvoertabel",
    "Upload": "Upload firmware",
    "Input_form": "Invoertabel",
    "upgrade1": "Upgrade",
    "more": "Meer Acties",
    "one_click_read": "Lees met één Klik",
    "device_code_form": "Communicatieprotocol:",
    "power": "Vermogen",
    "device_sn": "Apparaat SN",
    "bought": "Elektriciteit kopen",
    "cur_thisyear": "Dit jaar",
    "upSuccessDevice": "Met succes opgewaardeerde apparaten",
    "proList": "Projectlijst",
    "serial_number": "Apparaat SN:",
    "grid": "Elektriciteitsnet",
    "control_firmware_slavmcu": "SlavMCU firmware",
    "report": "Rapportformulieren",
    "upgradeType": "Upgrademethode:",
    "device_upgrade1": "Laatste upgraderecord",
    "uploadSuccess": "Upload succesvol",
    "Current_data": "Huidige gegevens",
    "Upload1": "Nieuwe firmware uploaden",
    "Send_Input": "Voer de te verdelen verrichtingswaarde in",
    "device_type": "Type apparatuur",
    "selecParameters": "Geselecteerde parameter",
    "used": "Elektriciteitsverbruik",
    "System_Failed": "Vanwege communicatieafwijkingen of andere redenen kon het systeem het upgradeproces van het apparaat niet starten",
    "Unit": "Eenheid",
    "modifySuc": "Met succes gewijzigd",
    "cur_year": "Jaar",
    "firmware_type_message": "Selecteer een type",
    "such_as": "Bijvoorbeeld: AA BB CC DD EE FF",
    "day": "Realtime stroom",
    "obtain": "Verkrijgen",
    "all": "Totaal elektriciteit",
    "device_status": "Apparaatstatus",
    "read": "Lezen",
    "deleteDevice": "Apparaat verwijderen",
    "update_suc": "Upgrade succesvol",
    "admin_authority": "Beheersrechten",
    "continueUpgradeSuccess": "Succesvol geüpgraded en toegevoegd",
    "send": "Instructies verzenden",
    "control_firmware1": "Controle firmware 1",
    "datalogger": "Gegevensverzameling",
    "control_firmware2": "Control Firmware 2",
    "device_upgradeProgress": "Upgradevoortgang",
    "Operation": "Werking",
    "delete": "Verwijderen",
    "addUpgrade": "Upgradetaak toevoegen",
    "Device_Offline": "Het apparaat of de gegevensverzamelaar is offline",
    "Field_Name": "Veldnaam",
    "device_upgradeFirmware": "Selecteer een firmware pakket om het apparaat te upgraden",
    "Voltage": "Spanning",
    "Update_Completed": "Upgrade voltooid",
    "parameter": "Parameter",
    "device_continueUpgrade": "Apparatuur blijft upgraden",
    "moveResults": "Resultaten verplaatsen",
    "value": "Waarde",
    "chooseProtocol": "Selecteer protocol:",
    "sellProfit_Today": "Dagelijkse inkomsten uit de elektriciteitsverkoop",
    "sellProfit_Total": "Totale inkomsten uit de verkoop van elektriciteit",
    "optionalParam": "Facultatieve parameters",
    "fileExceed": "Bestand te groot",
    "debug": "Debuggen",
    "Electric": "Huidige",
    "fault": "Fout",
    "control": "Controle",
    "select_firmware": "Firmware:",
    "follow": "Volgen",
    "upBatchDeviceTip": "Opmerking: Batch upgrade is het upgraden van meerdere apparaten naar dezelfde firmware. Als u niet zeker weet welke firmware geschikt is voor het apparaat, kies dan zorgvuldig!",
    "cloudsUpgrade": "Cloud upgrade",
    "device_upgradeName": "Naam firmware upgraden",
    "instruction_response": "Commando verzenden, wachten op antwoord",
    "error1": "Alleen bestanden in de formaten \". bin\" en \". hex\" kunnen worden geüpload",
    "dataview": "Realtime parameters"
  },
  "account": {
    "cancel": "Annuleren",
    "Delete": "Verwijderen",
    "enterHome": "Voer de startpagina in",
    "reason1": "Het apparaat heeft momenteel geen gegevens",
    "reason": "De reden voor het niet weergeven van de grafiek kan zijn:",
    "role1": "Gebruikerstype:",
    "reason2": "Er zijn geen parametervelden voor stroomopwekking, verbruik, aankoop, verkoop, opladen en ontlading in de apparatuurovereenkomst",
    "projects": "Project",
    "reason3": "Het apparaatprotocol heeft geen parametervelden voor het genereren van stroom, laadvermogen, batterijvermogen en netvermogen",
    "resetPwdSuc": "Wachtwoord resetten succesvol",
    "newPwd": "Nieuw wachtwoord",
    "deleteSuc": "Succesvol verwijderd",
    "binding": "Binding",
    "Edit": "Bewerken",
    "groupsuccess": "Groepering succesvol!",
    "createSuc": "Account met succes aangemaakt",
    "generalAccount": "Gewone rekening",
    "Individual_allocation": "Individuele toewijzing",
    "password": "Gebruikerswachtwoord",
    "enablesuccess": "Succesvol ingeschakeld!",
    "enable": "Inschakelen",
    "searchPro": "Zoeken naar items",
    "accountManage": "Accountbeheer",
    "relatedOwner": "Gerelateerde eigenaren",
    "confirmpassword": "Wachtwoord bevestigen",
    "nickname1": "Gebruikersbijnaam:",
    "Assigned_successfully": "Toegewezen met succes",
    "Confirm_assignment": "Toewijzing bevestigen aan",
    "selectUserType": "Selecteer een gebruikerstype",
    "PNNum": "PN-nummer",
    "devices": "Apparaten",
    "deletegroup": "Groep verwijderen",
    "adminRelated": "Selecteer een beheerder",
    "createAccount": "Een account aanmaken",
    "operate": "Werking",
    "groupManage": "Groepsbeheer",
    "Distribution_method": "Toewijzingsmethode",
    "IsIt": "Is het",
    "userAccount": "Gebruiker",
    "deleteUser": "Account verwijderen",
    "projectNum": "Projecthoeveelheid",
    "deletegroupsuccess": "De groep is succesvol verwijderd!",
    "afterEnable": "Na activering kan het account opnieuw inloggen, relevante inhoud van het account bekijken of wijzigen",
    "changeGroupSuc": "De groep is succesvol verplaatst",
    "role": "Type klant",
    "disablesuccess": "Geslaagd!",
    "groupto": "Groeperen naar",
    "Distribution_collector": "Allocatieverzamelaar",
    "confirmDisable": "Weet je zeker dat je deze gebruiker uitschakelt?",
    "accountStatus": "Gebruikersstatus",
    "groupAccount": "Groepering",
    "defaultGroup": "Standaard groepering",
    "nickname": "Gebruikersbijnaam",
    "password1": "Gebruikerswachtwoord:",
    "email": "Postvak",
    "order_check": "Controle",
    "relatedSuccess": "Succesvol geassocieerd",
    "Deletesuccessfully": "Account succesvol verwijderd!",
    "powerStationOwner": "Eigenaar van een elektriciteitscentrale",
    "err_orderNum": "In de volgorde",
    "tooltipContent": "Beheerders kunnen alle gegevensverzamelaars onder een bestelling toewijzen aan een ondergeschikte dealer via het bestelnummer",
    "distributor": "Dealer",
    "Allocation_result": "Toewijzingsresultaten",
    "confirm": "Bevestigen",
    "ownedDevices": "Eigen apparaten",
    "resetPwd": "Wachtwoord opnieuw instellen",
    "activeStatus": "Activiteitsniveau",
    "createTime": "Aanmaaktijd",
    "placeholder1": "Vul uw gebruikersnaam/telefoonnummer in",
    "disable": "Uitgeschakeld",
    "accounts": "Gebruikers",
    "lastLogin": "Laatste aanmelding",
    "allGroup": "Alle groepen",
    "confirmpassword1": "Wachtwoord bevestigen:",
    "editUser": "Gebruiker bewerken",
    "cannotRedirect": "Dit account is geen opslagaccount en kan niet worden omgeleid",
    "modifiedsuccess": "Succesvol gewijzigde gebruikersinformatie!",
    "email1": "E-mail:",
    "manageAccount": "Administrator account",
    "Order_allocation": "Opdrachttoewijzing",
    "finish": "Compleet",
    "group": "Groepering",
    "changeGroup": "Groep verplaatsen naar:",
    "limitFormat": "Alleen bestanden in de formaten \"xlsx\" en \"xls\" kunnen worden geüpload",
    "ascription": "Toekenning",
    "ascriptionSuccess": "Succesvol toebehoren",
    "ascription_result": "Toewijzingsresultaat",
    "newPwd1": "Nieuw wachtwoord:",
    "group1": "Groepering:",
    "disableSuc": "Geslaagd uitgeschakeld",
    "currentTotal": "Huidige totaal",
    "uselists": "Gebruikersbeheerlijst",
    "powerStationViewer": "Power Station Viewer",
    "afterDisable": "Na het uitschakelen kan het account niet inloggen, de gerelateerde inhoud bekijken of wijzigen",
    "unclassified": "Ongegroepeerd",
    "submit": "Verzenden",
    "newPwdEmpty": "Het nieuwe wachtwoord kan niet leeg zijn, vul het in!",
    "accountName": "Gebruikersnaam",
    "pwdresetsuccess": "Wachtwoord reset succesvol!",
    "order_number": "Ordernummer",
    "mobile1": "Mobiel:",
    "admin": "Beheerders",
    "riyueyuan_lineSonAdmin": "Subbeheerder productielijn",
    "riyueyuan_SonAdmin": "Subbeheerder",
    "plantOwner": "Eigenaar van een elektriciteitscentrale",
    "accountName1": "gebruikersnaam",
    "accountName2": "Voer één gebruikersnaam in",
    "Batch_allocation": "Batch toewijzing",
    "deviceNum": "Aantal hulpmiddelen",
    "chooseGroup": "Selecteer een groep",
    "editAccount": "Account bewerken",
    "notRecovered": "Na verwijdering kan het niet worden hersteld",
    "placeholder": "Zoeken naar gebruikersnaam/telefoonnummer",
    "accountRole": ".Rol",
    "Ple_orderNum3": "Verzamelaars, bevestig toewijzing aan",
    "Ple_orderNum2": "Dit bevel heeft",
    "Ple_orderNum": "Voer het bestelnummer in",
    "Ple_orderNum1": "Voer het juiste bestelnummer in",
    "lastLoginTs": "Laatste aanmeldingstijd",
    "mobile": "Mobiele telefoon",
    "accountGroup": "Gebruikersgroepering",
    "nodata": "Er zijn momenteel geen gegevens beschikbaar",
    "allTypeUser": "Alle soorten gebruikers",
    "confirmDelete": "Weet je zeker dat je het verwijdert?",
    "confirmEnable": "Weet u zeker dat u deze gebruiker inschakelt?",
    "dataloggerNum": "Aantal gegevensverzamelaars",
    "allAccount": "Alle gebruikers",
    "title_pwd": "Voer het juiste wachtwoord in",
    "title_pwd1": "Voer een 6-32 bit wachtwoord in",
    "title_pwd2": "Voer het nieuwe wachtwoord opnieuw in",
    "title_mobile": "Voer een 11-cijferig telefoonnummer in",
    "title_edit": "Gelieve de te bewerken informatie in te voeren",
    "title_info": "Vul het juiste e-mailadres in",
    "title_info1": "Voer het juiste telefoonnummer in",
    "err_orderNum1": "Gelieve te bevestigen dat de verzamelaars in de bestelling niet gebonden zijn.",
    "accountList": "Accountlijst",
    "dataogger_swith": "Data-acquisitie-apparaat toevoegen",
    "dataogger_swithTip": "Kan dit account de machtiging hebben om gegevensverzamelaars toe te voegen",
    "account_number": "Rekeningnummer",
    "Role_authority": "Jurisdictie",
    "authority_Management": "Toestemmingsbeheer",
    "Related_roles": "Gerelateerde rollen",
    "Ple_role1": "Selecteer de bijbehorende rol",
    "Ple_role2": "Voer de rolnaam/ID in",
    "Add_role": "Nieuwe rol toevoegen",
    "Edit_role": "Rol bewerken",
    "Role_id": "Rol-ID",
    "Role_name": "Rolnaam",
    "Ple_role3": "Voer de rolnaam in",
    "Role_des": "Rolbeschrijving",
    "Ple_role4": "Voer een rolbeschrijving in",
    "module": "Modulair",
    "First_page": "Pagina",
    "Secondary_page": "Secundaire pagina",
    "Function_points": "Functie",
    "Remove_role": "Rol verwijderen",
    "Ple_role5": "Controleer de accountrechten",
    "No_permission_prompt": "Geen toestemming, neem contact op met de beheerder op hoger niveau",
    "Ple_role6": "De rolnaam bestaat al, voer opnieuw in",
    "limit_UserTypeNum": "Bij overschrijding van de limiet bestaat dit accounttype al",
    "limit_UserTypeDataPermission": "Dealersaccounts kunnen geen rollen binden met geselecteerde gegevensmachtigingen.",
    "edit_limit_UserTypeDataPermission": "De rol is gekoppeld aan een dealeraccount en de gegevensmachtigingen kunnen niet worden bewerkt.",
    "dataPermission": "Gegevensmachtiging",
    "functionalPermission": "Functionele machtiging"
  },
  "browse": {
    "pleaseUsr": "Voer een subaccount in",
    "deleteBrowse": "Verwijderen",
    "pleaseDevice": "Project selecteren",
    "editBrowse": "Subaccount bewerken",
    "addSuccess": "Subrekening met succes toegevoegd",
    "password": "Wachtwoord",
    "usr": "Subrekening",
    "pleaseDevice_title": "Selecteer een project",
    "deleteSuccess": "Succesvol verwijderd",
    "confirmPassword": "Wachtwoord bevestigen",
    "Enable": "Inschakelen",
    "Disable": "Uitgeschakeld",
    "email": "Postvak",
    "accountInfo": "Accountinformatie",
    "delete_browse": "Weet je zeker dat je het subaccount verwijdert?",
    "addBrowse": "Subaccount toevoegen",
    "gts": "Registratiedatum",
    "mobile": "Mobiele telefoon",
    "newPassword": "Nieuw wachtwoord",
    "editSuccess": "Subaccount succesvol bewerkt",
    "please_browsepwd": "Controleer het nieuwe wachtwoord en bevestig de wachtwoordinvoervereisten",
    "pleaseStatus": "Status selecteren",
    "device": "Projectselectie",
    "usrInfo": "Gebruikersinformatie",
    "enableStatus": "Status inschakelen",
    "username": "Gebruikersnaam",
    "desc": "Opmerkingen"
  },
  "collectionFrequencyUP": {
    "collect_fast": "Versnelling van energie-stroomgegevensverzameling",
    "collect_fast2": "Energieversnelling",
    "collect_fast_fail": "Versnelling mislukt, probeer het opnieuw",
    "collect_fasting": "Versnelen",
    "collect_fast_starting": "Versnelling wordt gestart",
    "collect_fast1": "Versnelling van gedetailleerde gegevensverzameling",
    "collect_fast1ing": "Versnelde gegevens",
    "paySecCon": "Betalingsbevestiging",
    "energyFetchPic": "Of het bevestigen van het opladen, het versnellingsbereik van het opladen is de parameters van de pagina van de stroomkaart van energie zoals in de volgende afbeelding",
		"historyFetchPic": "Of het bevestigen van het opladen, het versnellingsbereik van het opladen voor gegevens gedetailleerde pagina parameters zoals in de volgende afbeelding",
		"reRechargeTip1": "Het huidige apparaat heeft de versnellingsdienst voor energiestroom al gekocht. Doorgaan met de aankoop zal opnieuw kosten met zich meebrengen. Wilt u doorgaan?",
		"reRechargeTip": "Het huidige apparaat heeft de versnellingsdienst voor gegevensdetails al gekocht. Doorgaan met de aankoop zal opnieuw kosten met zich meebrengen. Wilt u doorgaan?",
		"continueRecharge": "Doorgaan met opladen",
    "collect_fasting_title": "Real-time parameters worden niet opgeslagen",
    "collect_Order_Record": "Versnelde registratie",
    "Collection_terms": "Termen voor het opladen van de verzamelfrequentie",
    "Recharge_failed_next": "Sorry voor het mislukte opladen, u kunt opnieuw proberen te betalen",
    "view_order": "Orders bekijken",
    "Once": "tweede",
    "every_interval": "De momenteel geselecteerde acceleratie specificatie is: elk interval",
    "Collect_terms2": "1,Toepassingsgebied van de verpakking",
    "Collect_terms3": "De weergaveparameters die zijn opgenomen in het protocol dat door de collector wordt gebruikt voor uw opladen (let op: als u de pagina Energiestroomgrafiek selecteert voor versnelde opladen, is het bereik van het pakket beperkt tot het weergaveparameterbereik van de pagina Energiestroomgrafiek; als u de pagina Historische gegevens selecteert voor versnelde opladen, is het bereik van de verpakking beperkt tot het weergaveparameterbereik van de pagina Historische gegevens)",
    "Collect_terms4": "2,Niet ondersteuning van protocol/device vervanging",
    "have_read": "Ik heb het grondig gelezen.",
    "Collect_terms5": "Het wijzigen van protocollen/apparaten neemt niet deel aan het acceleratievermogen",
    "Collect_terms6": "3,Abonnement opzeggen",
    "Collect_terms": "Termijnen voor versnelde opladen verzamelen",
    "View_Details": "Details bekijken",
    "Recharge_result": "Oplaadresultaat",
    "Collect_terms7": "Afmelden en wijzigen niet ondersteund na betaling",
    "Online_payment": "Online betaling",
    "Collect_terms8": "4,4,Pakketprijs",
    "Collect_terms9": "Onze vergoedingen worden berekend op basis van uw parameterhoeveelheid, versnelde inzamelingsfrequentie en laadcapaciteit, en de uiteindelijke prijs wordt dienovereenkomstig bepaald; Naast bovenstaande voorwaarden hebben historische gegevens ook opslagtijd met zich mee te maken",
    "acquisition_frequency": "Verzamelfrequentie",
    "Recharge_failed": "Opladen mislukt",
    "Recharge_amount": "Oplaadbedrag",
    "Scan_payment": "Betaling met scancode",
    "collect_recharge": "Opladen van verzamelingsversnelling (versnelling van gedetailleerde gegevensverzameling)",
    "collect_recharge1": "Opladen van verzamelingsversnelling (versnelling van energiestroom)",
    "Collect_terms10": "5,Verkeersverbruik",
    "Purchase_Terms7": "Er zijn nog andere vragen.",
    "Purchase_Terms8": "Als u andere vragen heeft, kunt u contact opnemen met onze online klantenservice voor advies, en wij zullen u voorzien van gedetailleerde antwoorden",
    "Collect_terms11": "Het versnellen van de verzamelfrequentie zal het verkeersverbruik verhogen",
    "Purchase_Terms6": "Onze vergoedingen worden berekend op basis van uw parameterhoeveelheid, versnelde inzamelingsfrequentie en laadcapaciteit, en de uiteindelijke prijs wordt dienovereenkomstig bepaald; Naast bovenstaande voorwaarden hebben historische gegevens ook opslagtijd met zich mee te maken",
    "Purchase_Terms5": "Pakketprijs",
    "Purchase_Terms4": "Kijk uit naar onze nieuwe versie. De huidige versie ondersteunt alleen het verzamelen en upgraden van alle weergaveparameters. Onze excuses voor het ongemak veroorzaakt!",
    "Purchase_Terms3": "Kan ik de upgrade van de verzamelfrequentie voor sommige parameters niet aanpassen",
    "Real_parameters": "Realtime parameters",
		"Purchase_Terms1": "Geldigheidsperiode van verzamelingsversnelling",
		"Purchase_Terms2": "De vervaldatum van de verzamelingsversnellingsdienst wordt automatisch berekend op basis van de duur van het door u aangeschafte pakket. De specifieke vervaldatum is afhankelijk van de weergave op de pagina",
    "device_Info": "Apparaat-informatie",
    "Recharge_successful_next": "Gefeliciteerd met uw succesvolle oplaadbeurt. We staan op het punt om uw afhaalfrequentie te upgraden, en u kunt vanaf nu uw afhaalfrequentie volgen",
    "Purchase_Terms": "Aankoopvoorwaarden",
    "gather": "collectie",
    "Recharge_time": "Oplaadtijd",
    "Payment_method": "Betalingsmethode",
    "Type": "Type opvulling",
    "Recharge_now": "Nu opladen",
    "History_Data": "historische gegevens",
    "Collect_terms1": "Servicevoorwaarden voor versnelling van de inzamelingsfrequentie",
    "Package": "Versnellingspakket",
    "PN_order": "PN/ordernummer",
    "Order_No": "Ordernummer",
    "Recharge_successful": "Opgeladen met succes",
    "noRecharg": "De collector ondersteunt niet opladen",
    "noRecharg_min": "Je verzamelsnelheid is het snelst!",
    "noRecharg_wifi": "De huidige versie ondersteunt alleen gegevensverzameling met Wi-Fi-module",
    "paypalTip": "Het uiteindelijke betalingsbedrag is gebaseerd op PayPal",
    "upPrice": "Verschil",
  },
  alarmNew: {
    'fileName': 'Bestandsnaam',
    'fileSize': 'Bestandsgrootte',
    'fileStatus': 'Bestandstatus',
    'progress': 'Voortgang',
    'can': 'Downloadbaar',
    'no': 'In exportatie',
    'history': 'Exportgeschiedenis'
  },
  	shuoriExport:{
    "exportRecords": "Record di esportazione",
    "export": "Esporta",
    "exportTask": "L'attività di esportazione è stata creata. Scaricala successivamente nei Record di esportazione.",
    "noDownload": "L'indirizzo del file non è valido o non è possibile scaricarlo. Riprova.",
    'data': 'Datum',
	},
  	colUnBindRecord: {
    'UnBindRecord': 'Ontkoppelingsgeschiedenis van de datacollector',
    "unStatus": "Ontkoppelingsstatus",
    "unScene": "Ontkoppelingsscenario",
    "oldUser": "Oorspronkelijke gebruiker",
    "newUser": "Nieuwe gebruiker",
    "unCount": "Aantal ontkoppelingen",
    "pnBarCode": "PN-streepjescode",
    "devicePicture": "Foto van het daadwerkelijke apparaat",
    "ip": "Losgekoppelde IP",
    "unTime": "Ontkoppelingstijd"
	},
  	rosRecharge: {
		'electronicInvoicing': 'Elektronische facturering',
		'issueEInvoice': 'E-factuur uitreiken',
		'invoiceHistory': 'Factuurgeschiedenis',
		'rechargeDuration': 'Oplaadduur',
		'year': 'Jaar',
		'month': 'Maand',
		'day': 'Dag',
		'days': 'Dagen',
		'pendingPayment': 'Wachten op betaling',
		'paymentSuccess': 'Betaling geslaagd',
		'paymentFailed': 'Betaling mislukt',
		'orderClosed': 'Bestelling gesloten',
		'serviceTerminated': 'Dienst beëindigd',
		'unpaid': 'Niet betaald',
		'paying': 'Betaling bezig',
		'paid': 'Betaald',
		'refunded': 'Terugbetaald',
		'cancelled': 'Geannuleerd',
		'rechargeSuccess': 'Opladen geslaagd',
		'rechargeFailed': 'Opladen mislukt',
		'pleaseSelectDate': 'Selecteer een datum',
		'orderNo': 'Bestelnummer',
		'batchInvoicing': 'Batchfacturering',
		'rechargeType': 'Oplaadtype',
		'trafficRecharge': 'Data opladen',
		'collectRecharge': 'Verzameling opladen',
		'rechargeStatus': 'Oplaadstatus',
		'invoice': 'Factuur',
		'invoiceStatus': 'Factuurstatus',
		'invoiceTime': 'Factuurmoment',
		'viewDetail': 'Details bekijken',
		'invoicing': 'Bezig met factureren',
		'invoiceSuccess': 'Factuur succesvol uitgemaakt',
		'invoiceFailed': 'Facturering mislukt',
		'issueElectronicInvoice': 'E-factuur uitreiken',
		'invoiceType': 'Factuurtype',
		'generalInvoice': 'Gewone factuur',
		'specialInvoice': 'Speciale factuur',
		'headerType': 'Type briefhoofd',
		'companyHeader': 'Bedrijfsbriefhoofd',
		'personalHeader': 'Persoonlijk/Niet-zakelijk',
		'pleaseInputCompanyHeader': 'Vul het bedrijfsbriefhoofd in',
		'taxNumber': 'Bedrijfsbelastingnummer',
		'pleaseInputTaxNumber': 'Vul het BTW-identificatienummer in',
		'headerName': 'Naam briefhoofd',
		'suggestPersonalName': 'Aanbevolen: persoonlijke naam / winkelnaam',
		'invoiceContent': 'Factuurinhoud',
		'internetCommService': 'Internetcommunicatiediensten',
		'invoiceAmount': 'Factuurbedrag',
		'yuan': 'Yuan',
		'moreInfo': 'Meer informatie',
		'remarkAddressEtc': 'Opmerking, adres, enz.',
		'companyAddress': 'Bedrijfsadres',
		'pleaseInputCompanyAddress': 'Voer het bedrijfsadres in',
		'companyPhone': 'Bedrijfstelefoon',
		'pleaseInputCompanyPhone': 'Voer het bedrijfstelefoonnummer in',
		'openingBank': 'Rekeningbank',
		'pleaseInputOpeningBank': 'Voer de rekeningbank in',
		'bankAccount': 'Bankrekeningnummer',
		'pleaseInputBankAccount': 'Voer het bankrekeningnummer in',
		'remark': 'Opmerking',
		'pleaseInputRemark': 'Voer een opmerking in',
		'email': 'E-mailadres',
		'pleaseInputEmail': 'Vul het e-mailadres in',
		'cancel': 'Annuleren',
		'submit': 'Indienen',
		'invoiceResult': 'Factuurresultaat',
		'invoiceSubmitted': 'Factuurverzoek ingediend',
		'invoiceExpectedTip': 'De factuur wordt naar verwachting binnen 48 uur uitgemaakt. Let op de ontvangst.',
		'viewInvoiceStatus': 'Factuurstatus bekijken',
		'pleaseInputHeaderName': 'Vul de naam van het briefhoofd in',
		'pleaseInputValidEmail': 'Voer een geldig e-mailadres in',
		'invoiceApplyFailed': 'Factuurverzoek mislukt',
		'viewInvoice': 'Factuur bekijken',
		'downloadPdf': 'PDF-bestand downloaden',
		'manualService': 'Klantenservice',
		'invoiceSentToEmail': 'De factuurinformatie is per e-mail verzonden. Let op de ontvangst.',
		'pleaseWaitInvoicing': 'Wacht geduldig tot de facturering is voltooid',
		'pleaseContactManual': 'Neem contact op met de klantenservice voor facturering',
		'noPdfAvailable': 'Geen downloadbaar PDF-bestand beschikbaar',
		'serviceUnavailable': 'Klantenservicefunctie tijdelijk niet beschikbaar',

	}
}
export default nl;